const scholarsDataObj = {
  "2":{
     "0":{
        sortingKey:"(d. 114/733)",
        scholarName:"Imām al-Bāqir ",
        death:"(d. 114/733)"
     },
   "1":{
        scholarName:"Abū Manṣūr al-ʿIjlī ",
        death:"(d. 121/738)",
        sortingKey:"(d. 121/738)"
     },
     "2":{
        death:"(d. 122/740)",
        sortingKey:"(d. 122/740)",
        scholarName:"Zayd b. ʿAlī "
     },
     "3":{
        sortingKey:"(d. 128/ 746)",
        scholarName:"Jābir b. Yazīd b. al-Juʿfī ",
        death:"(d. c. 128/ 746)"
     },
     "4":{
        death:"(d. c. 131/749)",
        sortingKey:"(d. 131/749)",
        scholarName:"Abū Muḥammad ʿAbdullāh b. Abī Yaʿfūr al-ʿAbdī al-Kūfī, Ibn Abī Yaʿfūr "
     },
     "5":{
        sortingKey:"(d. 133/750 or 138/755 or 145/762)",
        scholarName:"Ismāʿil b. Jaʿfar ",
        death:"(d. 133/750 or 138/755 or 145/762)"
     },
     "6":{
        scholarName:"Abān b. Abī ʿAyyāsh (Fīrūz) al-Baṣrī al-Tābiʿī ",
        death:"(d. 138/755)",
        sortingKey:"(d. 138/755)"
     },
     "7":{
        death:"(d. 140/757 or 200/815)",
        sortingKey:"(d. 140/757 or 200/815)",
        scholarName:"Abān b. ʿUthmān al-Aḥmar al-Bajalī al-Kūfī "
     },
     "8":{
        sortingKey:"(d. 141/758)",
        scholarName:"Abān b. Taghlib al-Kindī al-Kūfī ",
        death:"(d. c. 141/758)"
     },
     "9":{
        sortingKey:"(d. 145/762)",
        scholarName:"ʿAbdullāh b. al-Ḥasan al-Muthanna, ʿAbdullāh al-Maḥḍ ",
        death:"(d. 145/762)"
     },
     "10":{
        sortingKey:"(d. 145/762)",
        scholarName:"Muḥammad b. ʿAbdullāh b. al-Ḥasan, al-Nafs al-Zakiyya ",
        death:"(d. 145/762)"
     },
     "11":{
        sortingKey:"(d. 148/765)",
        scholarName:"Ḥarīz b. ʿAbdullāh al-Sijistānī ",
        death:"(d. before 148/765)"
     },
     "12":{
        death:"(d. before 148/765)",
        sortingKey:"(d. 148/765)",
        scholarName:"ʿUbaydullāh b. ʿAlī al-Ḥalabī "
     },
     "13":{
        sortingKey:"(d. 148/765)",
        scholarName:"al-Fuḍayl b. Yasār al-Nahdī ",
        death:"(d. before 148/765)"
     },
     "14":{
        death:"(d. before 148/765)",
        sortingKey:"(d. 148/765)",
        scholarName:"Abū Jahm Bukayr b. Aʿyan b. Sunsun al-Shaybānī al-Kūfī "
     },
     "15":{
        death:"(d. before 148/765)",
        sortingKey:"(d. 148/765)",
        scholarName:"ʿAbd al-Malik b. Aʿyan al-Shaybānī al-Kūfī, Abū Ḍurays "
     },
     "16":{
        death:"(d. 148/765)",
        sortingKey:"(d. 148/765)",
        scholarName:"Imām al-Ṣādiq "
     },
     "18":{
        scholarName:"ʿAbdullāh b. Jaʿfar al-Afṭaḥ ",
        death:"(d. 148/765)",
        sortingKey:"(d. 148/765)"
     },
     "19":{
        scholarName:"Burayd b. Muʿāwiya al-ʿIjlī ",
        death:"(d. c. 148/765)",
        sortingKey:"(d. 148/765)"
     },
     "20":{
        death:"(d. c. 148/765)",
        sortingKey:"(d. 148/765)",
        scholarName:"Ḥumrān b. Aʿyan "
     },
     "21":{
        scholarName:"Ziyād b. al-Mundhir, Abū al-Jārūd ",
        death:"(d. 150/767 or 160/777)",
        sortingKey:"(d. 150/767 or 160/777)"
     },
     "22":{
        scholarName:"Zurāra b. Aʿyan b. Sunsun al-Shaybānī al-Kūfī ",
        death:"(d. 150/767)",
        sortingKey:"(d. 150/767)"
     },
     "23":{
        death:"(d. 150/767 or 177/793)",
        sortingKey:"(d. 150/767 or 177/793)",
        scholarName:"Muḥammad b. Muslim al-Ṭāʾifī al-Thaqafī al-Kūfī "
     },
     "24":{
        death:"(d. 150/767)",
        sortingKey:"(d. 150/767)",
        scholarName:"Thābit b. Dinār al-Thumālī, Abū Ḥamza al-Thumālī "
     },
     "25":{
        scholarName:"Yaḥyā b. Abī al-Qāsim al-Kūfī, Abū Baṣīr al-Asadī ",
        death:"(d. 150/767)",
        sortingKey:"(d. 150/767)"
     },
     "26":{
        sortingKey:"(d. 2nd/8th century)",
        scholarName:"Layth b. al-Bakhtarī al-Murādī, Abū Baṣīr al-Murādī ",
        death:"(d. 2nd/8th century)"
     },
     "27":{
        scholarName:"ʿAbdullāh b. Bukayr b. Aʿyan b. Sunsun al-Shaybānī, Abū ʿAlī al-Shaybānī ",
        death:"(d. 2nd/8th century)",
        sortingKey:"(d. 2nd/8th century)"
     },
     "28":{
        death:"(d. between 151-160/768-777)",
        sortingKey:"(d. 151-160/768-777)",
        scholarName:"Maʿrūf b. Kharrabūz al-Makkī "
     },
     "29":{
        sortingKey:"(d. 157/774)",
        scholarName:"Abū Mikhnaf Lūṭ b. Yaḥyā b. Saʿīd b. Mikhnaf b. Sulaym al-Ghāmidī al-Azdī ",
        death:"(d. 157/774)"
     },
     "30":{
        death:"(d. 160/777 or after 180/796)",
        sortingKey:"(d. 160/777 or after 180/796)",
        scholarName:"Muḥammad b. ʿAlī b. al-Nuʿmān b. Abū Ṭarīfa al-Bajalī al-Kūfī, Muʾmin al-Ṭāq "
     },
     "31":{
        sortingKey:"(d. 161/778)",
        scholarName:"ʿAbd al-Malik b. Saʿīd, Ibn Abjar al-Kanānī ",
        death:"(fl. 161/778)"
     },
     "32":{
        death:"(d. 169/785)",
        sortingKey:"(d. 169/785)",
        scholarName:"al-Ḥusayn b. ʿAlī b. al-Ḥasan b. al-Ḥasan b. al-Ḥasan b. ʿAlī, Ṣāhib Fakhkh "
     },
     "33":{
        death:"(d. 173/789)",
        sortingKey:"(d. 173/789)",
        scholarName:"al-Sayyid Ismāʿīl al-Ḥimyarī, al-Sayyid al-Ḥimyarī "
     },
     "34":{
        sortingKey:"(d. 179/795) ",
        scholarName:"Hishām b. al-Ḥakam al-Kindī al-Baghdādī ",
        death:"(d. 179/795)"
     },
     "35":{
        sortingKey:"(d. 182/798)",
        scholarName:"ʿAlī b. Yaqṭīn b. Mūsā al-Baghdādī ",
        death:"(d. 182/798)"
     },
     "36":{
        scholarName:"ʿAbdullāh b. Muskān ",
        death:"(d. before 183/799)",
        sortingKey:"(d. 183/799)"
     },
     "37":{
        sortingKey:"(d. 2nd/8th century)",
        scholarName:" Thaʿlaba b. Maymūn al-Asadī al-Kūfī, Abū Isḥāq",
        death:"(d. 2nd/8th century)"
     },
     "38":{
        scholarName:"Imām al-Kāẓim ",
        death:"(d. 183/799)",
        sortingKey:"(d. 183/799)"
     },
     "39":{
        sortingKey:"(d. 2nd/8th century)",
        scholarName:"ʿAlī b. Riʾāb al-Ṭaḥḥān ",
        death:"(d. 2nd/8th century)"
     },
     "40":{
        scholarName:"al-Mufaḍḍal b. ʿUmar al-Juʿfī ",
        death:"(d. after 183/799)",
        sortingKey:"(d. 183/799)"
     },
     "41":{
        sortingKey:"(d. 183/799)",
        scholarName:"Hishām b. Sālim al-Jawālīqī al-Juʿfī ",
        death:"(fl. 183/799)"
     },
     "42":{
        sortingKey:"(d. 183/799)",
        scholarName:"ʿAbdullāh b. al-Mughīra al-Bajalī al-Kūfī al-Khazzāz ",
        death:"(fl. 183/799)"
     },
     "43":{
        sortingKey:"(d. 183/799)",
        scholarName:"Faḍāla b. Ayyūb al-Azdī al-Kūfī al-Ahwāzī ",
        death:"(fl. 183/799)"
     },
     "44":{
        scholarName:"Ibrāhīm b. Muḥammad b. Abī Yaḥyā ",
        death:"(d. 184/800)",
        sortingKey:"(d. 184/800)"
     },
     "45":{
        scholarName:"Abū al-Ḥasan Yaqṭīn b. Mūsā al-Baghdādī ",
        death:"(d. 186/802)",
        sortingKey:"(d. 186/802)"
     },
     "46":{
        sortingKey:"(d. 190/806)",
        scholarName:"Ḥammād b. ʿUthmān al-Nāb al-Fazārī al-ʿArzamī ",
        death:"(d. 190/806)"
     },
     "47":{
        sortingKey:"(d. 200/815)",
        scholarName:"ʿAbdullāh b. Sinān ",
        death:"(d. c. 200/815)"
     },
     "48":{
        sortingKey:"(d. 200/816)",
        scholarName:"Muḥammad b. al-Ḥusayn b. Zayd b. ʿAlī al-ʿAlawī al-Hāshimī, Muḥammad al-Maḥrūq ",
        death:"(d. 200/816)"
     },
     "49":{
        sortingKey:"(d. 200/816)",
        scholarName:"Jābir b. al-Ḥayyān al-Kūfī ",
        death:"(d. 200/816)"
     },
     "50":{
        scholarName:"ʿAlī b. Abī Ḥamza al-Baṭāʾinī ",
        death:"(d. c. 200/816)",
        sortingKey:"(d. 200/816)"
     },
     "101":{
        sortingKey:"(d. 132/750)",
        scholarName:"End of the Umayyad rule (40-132/661-750)",
        color:"#eeddbb",
        death:"(132/750)"
     },
     "102":{
        scholarName:"Beginning of the ʿAbbāsid caliphate (132-656/750-1258)",
        color:"#eeddbb",
        death:"(132/750)",
        sortingKey:"(d. 132/750)"
     },
     "103":{
        sortingKey:"(d. 2nd/8th century)",
        scholarName:"Abū al-ʿAbbās Faḍl b. ʿAbd al-Malik al-Baqbāq",
        death:"(d. 2nd/8th century)"
     }
  },
  "3":{
     "0":{
        sortingKey:"(d. 201/816)",
        scholarName:"Fāṭima b. Mūsā al-Kāẓim, Fāṭima al-Maʿṣūma ",
        death:"(d. 201/816)"
     },
     "1":{
        sortingKey:"(d. 203/818)",
        scholarName:"Jamīl b. Darrāj al-Nakhaʿī ",
        death:"(d. before 203/818)"
     },
     "2":{
        scholarName:"Imām al-Riḍā ",
        death:"(d. 203/818)",
        sortingKey:"(d. 203/818)"
     },
     "3":{
        sortingKey:"(d. 203/818)",
        scholarName:"Muḥammad b. Jaʿfar al-Ṣādiq, Muḥammad al-Dībāj ",
        death:"(d. 203/818)"
     },
     "4":{
        sortingKey:"(d. 203/818)",
        scholarName:"ʿUthmān b. ʿĪsā al-ʿĀmirī al-Kulābī al-Rawāsī ",
        death:"(alive before 203/818)"
     },
     "5":{
        sortingKey:"(d. 208/823)",
        scholarName:"Yūnus b. ʿAbd al-Raḥmān al-Juʿfī al-Kūfī ",
        death:"(d. c. 208/823)"
     },
     "6":{
        sortingKey:"(d. 208/823 or 209/824)",
        scholarName:"Ḥammād b. ʿĪsā al-Juhanī al-Kūfī al-Baṣrī ",
        death:"(d. 208/823 or 209/824)"
     },
     "7":{
        scholarName:"Ṣafwān b. Yaḥyā al-Bajalī al-Kūfī, Bayyāʿ al-Sāburī ",
        death:"(d. c. 210/825)",
        sortingKey:"(d. 210/825)"
     },
     "8":{
        scholarName:"ʿAlī b. Ismāʿīl al-Maythamī, Ibn Maytham, Abū al-Ḥasan al-Maythamī ",
        death:"(d. between 210-215/825-830)",
        sortingKey:"(d. 210-215/825-830)"
     },
     "9":{
        scholarName:"Naṣr b. Muzāḥim al-Minqarī ",
        death:"(d. 212/827)",
        sortingKey:"(d. 212/827)"
     },
     "10":{
        scholarName:"Muḥammad b. Abī ʿUmayr b. Ziyād b. ʿĪsā al-Azdī ",
        death:"(d. 217/832)",
        sortingKey:"(d. 217/832)"
     },
     "11":{
        scholarName:"Zakariyya b. Ādam al-Ashʿarī al-Qummī, Abū al-Jarīr al-Qummī ",
        death:"(d. 2nd/8th or 3rd/9th century)",
        sortingKey:"(d. 2nd/8th or 3rd/9th century)"
     },
     "12":{
        scholarName:"Imām al-Jawād ",
        death:"(d. 220/835)",
        sortingKey:"(d. 220/835)"
     },
     "13":{
        scholarName:"ʿAlī b. Jaʿfar al-Ṣādiq ",
        death:"(d. c. 220/835)",
        sortingKey:"(d. 220/835)"
     },
     "14":{
        sortingKey:"(d. 220/835)",
        scholarName:"Abū Jaʿfar Muḥammad b. Sinān al-Zāhirī ",
        death:"(d. c. 220/835)"
     },
     "15":{
        scholarName:"Aḥmad b. Muāḥmmad b. Abī Naṣr al-Bazanṭī ",
        death:"(d. 221/836)",
        sortingKey:"(d. 221/836)"
     },
     "16":{
        sortingKey:"(d. 224/839)",
        scholarName:"al-Ḥasan b. Maḥbūb al-Zarrād/al-Sarrād ",
        death:"(d. 224/839)"
     },
     "17":{
        sortingKey:"(d. 224/839)",
        scholarName:"al-Ḥasan b. ʿAlī b. Faḍḍāl al-Taymulī ",
        death:"(d. 224/839)"
     },
     "18":{
        sortingKey:"(d. 236/851)",
        scholarName:"ʿAbd al-Salām b. Ṣāliḥ, al-Khwāja Abū al-Ṣalt al-Harawī ",
        death:"(d. 236/851)"
     },
     "19":{
        scholarName:"Abū Yūsūf Yaʿqūb b. Isḥāq, al-Sikkīt ",
        death:"(d. 244/858)",
        sortingKey:"(d. 244/858)"
     },
     "20":{
        scholarName:"Muḥammad b. Hārūn al-Baghdādī, Abū ʿĪsā al-Warrāq ",
        death:"(d. 247/861 or 248/862)",
        sortingKey:"(d. 247 or 248/861 or 862)"
     },
     "21":{
        scholarName:"ʿAbbād b. Yaʿqūb al-Rawājinī ",
        death:"(d. 250/864)",
        sortingKey:"(d. 250/864)"
     },
     "22":{
        death:"(fl. mid-3rd/9th century)",
        sortingKey:"(d. mid-3rd/9th century)",
        scholarName:"Muḥammad b. ʿAlī b. Ibrāhīm al-Qurashī, Abū Sumayna "
     },
     "23":{
        sortingKey:"(d. mid-3rd/9th century)",
        scholarName:"Abū Jaʿfar al-Sakkāk ",
        death:"(d. mid-3rd/9th century)"
     },
     "24":{
        scholarName:"ʿAbd al-ʿAẓīm al-Ḥasanī, Shāh ʿAbd al-ʿAẓīm al-Ḥasanī ",
        death:"(d. 252/866)",
        sortingKey:"(d. 252/866)"
     },
     "25":{
        sortingKey:"(d. 254/868)",
        scholarName:"Imām al-Hādī ",
        death:"(d. 254/868)"
     },
     "26":{
        death:"(d. 254/868)",
        sortingKey:"(d. 254/868)",
        scholarName:"ʿAlī b. Mahziyār al-Ahwāzī al-Dawraqī "
     },
     "27":{
        sortingKey:"(d. 254/868)",
        scholarName:"al-Ḥusayn b. Saʿīd al-Ahwāzī ",
        death:"(d. after 254/868)"
     },
     "28":{
        sortingKey:"(d. 254/868)",
        scholarName:"ʿAlī b. Rayyān b. Ṣalt al-Ashʿarī al-Qummī ",
        death:"(d. after 254/868)"
     },
     "29":{
        death:"(d. c. 255/869)",
        sortingKey:"(d. 255/869)",
        scholarName:"Sahl b. Ziyād al-Ādamī al-Rāzī "
     },
     "30":{
        sortingKey:"(d. 258/872)",
        scholarName:"Fāris b. Ḥātam al-Qazwīnī ",
        death:"(d. 258/872)"
     },
     "31":{
        death:"(d. 260/874)",
        sortingKey:"(d. 260/874)",
        scholarName:"Imām al-ʿAskarī "
     },
     "32":{
        scholarName:"Ibrāhim b. Hāshim al-Qummī ",
        death:"(d. c. 260/873)",
        sortingKey:"(d. 260/873)"
     },
     "33":{
        sortingKey:"(d. 260/873)",
        scholarName:"al-Faḍl b. Shādhān b. Khalīl al-Azdī al-Nīshābūrī ",
        death:"(d. 260/873)"
     },
     "35":{
        death:"(d. 261/875)",
        sortingKey:"(d. 261/875)",
        scholarName:"Dāwūd b. al-Qāsim b. Isḥāq b. ʿAbdullāh b. Jaʿfar b. Abī Ṭālib, Abū Hāshim al-Jaʿfarī "
     },
     "36":{
        sortingKey:"(d. 262/875)",
        scholarName:"Muḥammad b. al-Ḥusayn b. Abī al-Khaṭṭāb Zayd al-Zayyāt al-Hamdānī al-Kūfī, Ibn Abī al-Khaṭṭāb ",
        death:"(d. c. 262/875)"
     },
     "37":{
        scholarName:"Abū ʿAmr ʿUthmān b. Saʿīd al-ʿAmrī ",
        death:"(d. around 267/880 or 280/893)",
        sortingKey:"(d. 267/880 or 280/893)"
     },
     "38":{
        scholarName:"Ibrāhīm b. Isḥāq al-Aḥmarī al-Nahāwandī ",
        death:"(d. 268/881)",
        sortingKey:"(d. 268/881)"
     },
     "39":{
        sortingKey:"(d. 271/884)",
        scholarName:"Jaʿfar b. ʿAlī al-Hādī, Jaʿfar al-Kadhdhāb ",
        death:"(d. 271/884)"
     },
     "40":{
        sortingKey:"(d. 274/888 or 280/894)",
        scholarName:"Aḥmad b. Muḥammad b. Khālid al-Barqī ",
        death:"(d. 274/888 or 280/894)"
     },
     "41":{
        scholarName:"Aḥmad b. Muḥammad b. ʿĪsā al-Ashʿarī ",
        death:"(fl. 274/887)",
        sortingKey:"(d. 274/887)"
     },
     "42":{
        sortingKey:"(d. 274/887)",
        scholarName:"al-Ḥakīmā bint Muḥammad al-Jawād, Ḥakīma Khātūn ",
        death:"(d. 274/887)"
     },
     "43":{
        death:"(d. 281/894)",
        sortingKey:"(d. 281/894)",
        scholarName:"Muḥammad b. Aḥmad b. Ibrāhīm b. Yūsuf al-Kātib "
     },
     "44":{
        sortingKey:"(d. 283/896)",
        scholarName:"Ibrāhīm b. Muḥammad b. Saʿīd b. Hilāl al-Iṣfahānī al-Thaqafī al-Kūfī, Ibn al-Hilāl al-Thaqafī ",
        death:"(d. 283/896)"
     },
     "45":{
        death:"(d. 284/897 or 292/904)",
        sortingKey:"(d. 284/897 or 292/904)",
        scholarName:"Aḥmad b. Abī Yaʿqūb Isḥāq b. Jaʿfar b. Wahab b. Wāḍiḥ, al-Yaʿqūbī "
     },
     "46":{
        scholarName:"Abū Yaʿqūb Isḥāq b. Muḥammad al-Nakhaʿī al-Baṣrī, al-Aḥmar ",
        death:"(d. 286/899)",
        sortingKey:"(d. 286/899)"
     },
     "47":{
        sortingKey:"(d. 290/903)",
        scholarName:"Abū Jaʿfar Muḥammad b. al-Ḥasan b. Farrūkh al-Ṣaffār al-Qummī ",
        death:"(d. 290/903)"
     },
     "48":{
        sortingKey:"(d. 3rd/9th century)",
        scholarName:"Muḥammad b. Yaḥyā al-ʿAṭṭār ",
        death:"(d. c. 3rd/9th century)"
     },
     "49":{
        death:"(d. after 293/905 or 305/917)",
        sortingKey:"(d. 293/905 or 305/917)",
        scholarName:"ʿAbdullāh b. Jaʿfar al-Ḥimyarī "
     },
     "50":{
        death:"(d. 296/909)",
        sortingKey:"(d. 296/909)",
        scholarName:"Mūsā b. Muḥammad al-Jawād, Mūsā al-Mubarqaʿ "
     },
     "51":{
        death:"(d. c. 3rd/9th century)",
        sortingKey:"(d. 3rd/9th century)",
        scholarName:"Thubayt b. Muḥammad al-ʿAskarī "
     },
     "52":{
        death:"(d. c. 3rd/9th century)",
        sortingKey:"(d. 3rd/9th century)",
        scholarName:"Dāwūd b. Asad al-Miṣrī, Abū Aḥwaṣ "
     },
     "53":{
        scholarName:"Abū al-Qāsim Saʿd b. ʿAbdullāh al-Ashʿarī al-Qummī ",
        death:"(d. between 299-301/911-913)",
        sortingKey:"(d. 299-301/911-913)"
     },
     "55":{
        scholarName:"Abū Muḥammad al-Ḥasan b. Mūsā al-Nawbakhtī ",
        death:"(d. between 300-316/912-922)",
        sortingKey:"(d. 300-316/912-922)"
     },
     "56":{
        sortingKey:"(d. 218/833)",
        scholarName:"Beginning of the Miḥna-Inquisition (218-233/833-848)",
        death:"(218/833)",
        color:"#eeddbb"
     },
     "57":{
        death:"(233/848)",
        color:"#eeddbb",
        sortingKey:"(d. 233/848)",
        scholarName:"End of the Miḥna–Inquisition (218-233/833-848)"
     },
     "58":{
        death:"(260/874)",
        color:"#eeddbb",
        sortingKey:"(d. 260/874)",
        scholarName:"Beginning of the Minor Occultation (260-329/874-941)"
     },
     "101":{
        sortingKey:"(d. 250/864)",
        scholarName:"Establishment of Zaydism in Northern Iran",
        death:"(250/864)",
        color:"#eeddbb"
     },
     "201":{
        scholarName:"Aḥmad b. Isḥāq al-Qummī ",
        death:"(d. 263/876)",
        sortingKey:"(d. 263/876)"
     }
  },
  "4":{
     "0":{
        sortingKey:"(d. 305/917)",
        scholarName:"Abū Jaʿfar Muḥammad b. ʿUthmān b. Saʿīd al-ʿAmrī ",
        death:"(d. 305/917)"
     },
     "1":{
        scholarName:"ʿAlī b. Ibrāhīm al-Qummī ",
        death:"(d. c. 307/919)",
        sortingKey:"(d. 307/919)"
     },
     "2":{
        death:"(d. 310/923)",
        sortingKey:"(d. 310/923)",
        scholarName:"Abū al-Qāsim Ḥumayd b. Ziyād al-Naynawāʾī "
     },
     "3":{
        scholarName:"Ḥusayn b. Manṣūr al-Ḥallāj ",
        death:"(d. 310/923)",
        sortingKey:"(d. 310/923)"
     },
     "4":{
        sortingKey:"(d. 310/923 or 314/927 or 319/930)",
        scholarName:"Aḥmad b. ʿUbaydullāh al-Thaqafī, Ibn ʿAmmār ",
        death:"(d. after 310/923 or 314/927 or 319/930)"
     },
     "5":{
        scholarName:"Abū Sahl Ismāʿīl b. ʿAlī b. Isḥāq al-Nawbakhtī ",
        death:"(d. 311/924)",
        sortingKey:"(d. 311/924)"
     },
     "6":{
        sortingKey:"(d. 4th/10th century)",
        scholarName:"Aḥmad b. Muḥammad b. Yazdiyār b. Rustam, al-Ṭabarī ",
        death:"(d. 4th/10th century)"
     },
     "7":{
        sortingKey:"(d. 312/925 or 320/933)",
        scholarName:"Abū Jaʿfar al-Iṣfahānī al-Karānī, Aḥmad b. ʿAlawiyya ",
        death:"(d. c. 312/925 or 320/933)"
     },
     "8":{
        sortingKey:"(d. 313/926)",
        scholarName:"Abū ʿAlī Muḥammad b. al-Ashʿath al-Kūfī, Ibn al-Ashʿath ",
        death:"(fl. 313/926)"
     },
     "9":{
        scholarName:"Abū Jaʿfar Muḥammad b. al-Ḥusayn al-Khathʿamī al-Ushnānī ",
        death:"(d. 315/928)",
        sortingKey:"(d. 315/928)"
     },
     "10":{
        sortingKey:"(d. 317/929)",
        scholarName:"Abū Jaʿfar Muḥammad b. ʿAbd al-Raḥmān, Ibn Qiba al-Rāzī ",
        death:"(d. before 317/929)"
     },
     "11":{
        death:"(d. 320/932 or 330/942)",
        sortingKey:"(d. 320/932 or 330/942)",
        scholarName:"Muḥammad b. Masʿūd al-ʿAyyāshī al-Samarqandī "
     },
     "12":{
        death:"(d. after 320/932)",
        sortingKey:"(d. 320/932)",
        scholarName:"Aḥmad b. Aʿtham b. Nadhīr b. Ḥubab b. Kaʿb al-Azdī al-Kūfī, Ibn al-Aʿtham al-Kūfī "
     },
     "13":{
        death:"(d. 323/934)",
        sortingKey:"(d. 323/934)",
        scholarName:"Muḥammad b. ʿAlī b. Abī al-ʿAzāqir al-Shalmaghānī "
     },
     "14":{
        death:"(d. 326/938)",
        sortingKey:"(d. 326/938)",
        scholarName:"al-Ḥusayn b. Rawḥ al-Nawbakhtī "
     },
     "15":{
        scholarName:"Hārūn b. Mūsā b. Aḥmad al-Tallaʿukbarī ",
        death:"(d. 328/940)",
        sortingKey:"(d. 328/940)"
     },
     "16":{
        sortingKey:"(d. 328/940)",
        scholarName:"Abū ʿAbdillāh Muḥammad b. ʿAbbās b. ʿAlī b. Marwān b. Mahiyār, Ibn Juḥām al-Bazzāz ",
        death:"(d. after 328/940)"
     },
     "17":{
        sortingKey:"(d. 329/941)",
        scholarName:"Abū al-Ḥasan ʿAlī b. Muḥammad al-Samarī/al-Samurī ",
        death:"(d. 329/941)"
     },
     "18":{
        sortingKey:"(d. 332/944)",
        scholarName:"Abū al-ʿAbbās Aḥmad b. Muḥammad b. Saʿīd al-Hamdānī, Ibn ʿUqda ",
        death:"(d. 332/944)"
     },
     "19":{
        scholarName:"Abū al-Ḥasan ʿAlī b. al-Ḥusayn b. Mūsā b. Bābawayh, Ibn Bābawayh ",
        death:"(d. 329/941)",
        sortingKey:"(d. 329/941)"
     },
     "20":{
        scholarName:"Abū Jaʿfar Muḥammad b. Yaʿqūb b. Isḥāq al-Kulaynī al-Rāzī ",
        death:"(d. 329/941)",
        sortingKey:"(d. 329/941)"
     },
     "21":{
        sortingKey:"(d. 4th/10th century)",
        scholarName:"al-Ḥasan b. Bisṭām b. Sābūr (Shāpūr) Zayʾat al-Wāsiṭī, Ibn Bisṭām ",
        death:"(d. 4th/10th century)"
     },
     "22":{
        death:"(fl. during minor occultation) ",
        sortingKey:"(d. during minor occultation) ",
        scholarName:"Abū Muḥammad al-Ḥasan b. ʿAlī al-Ḥadhdhāʾ al-ʿAmmānī/al-ʿUmmānī, Ibn Abī ʿAqīl "
     },
     "23":{
        death:"(d. c. 330/942)",
        sortingKey:"(d. 330/942)",
        scholarName:"Muḥammad b. Jaʿfar b. Buṭṭa al-Qummī, al-Muʾaddib "
     },
     "24":{
        scholarName:"Abū Aḥmad ʿAbd al-ʿAzīz b. Yaḥyā b. Aḥmad al-Baṣrī, ʿAbd al-ʿAzīz al-Jalūdī ",
        death:"(d. 330/942 or 332/944)",
        sortingKey:"(d. 330/942 or 332/944)"
     },
     "25":{
        sortingKey:"(d. 333/945)",
        scholarName:"Abū al-Ḥasan Muḥammad b. Aḥmad b. Dāwūd, Ibn Dāwūd al-Qummī ",
        death:"(d. before 333/945)"
     },
     "26":{
        scholarName:"Muḥammad b. Abī Bakr Hammām b. Suhayl b. Bīzān, Ibn Hammām al-Iskāfī ",
        death:"(d. 336/948)",
        sortingKey:"(d. 336/948)"
     },
     "27":{
        sortingKey:"(d. 340/951)",
        scholarName:"Muḥammad b. ʿUmar b. ʿAbd al-ʿAzīz al-Kashshī ",
        death:"(d. c. 340/951)"
     },
     "28":{
        scholarName:"Muḥammad b. al-Ḥasan b. Aḥmad al-Walīd, Ibn al-Walīd al-Qummī ",
        death:"(d. 343/954)",
        sortingKey:"(d. 343/954)"
     },
     "29":{
        sortingKey:"(d. 343/954)",
        scholarName:"ʿAlī b. Aḥmad b. Muḥammad b. Abī Jīd al-Qummī ",
        death:"(d. 343/954)"
     },
     "30":{
        sortingKey:"(d. 345/956 or 346/957)",
        scholarName:"Abū al-Ḥasan ʿAlī b. al-Ḥusayn al-Masʿūdī ",
        death:"(d. 345/956 or 346/957)"
     },
     "31":{
        sortingKey:"(d. 350/961)",
        scholarName:"Aḥmad b. Ibrāhīm b. Muʿallā b. Asad, Abū Bashr ʿAmmī ",
        death:"(d. after 350/961)"
     },
     "32":{
        death:"(d. 352/963)",
        sortingKey:"(d. 352/963)",
        scholarName:"ʿAlī b. Aḥmad b. Mūsā, Abū al-Qāsim al-Kūfī "
     },
     "33":{
        sortingKey:"(d. 352/963)",
        scholarName:"Furāt b. Ibrāhīm al-Kūfī ",
        death:"(d. 352/963)"
     },
     "34":{
        death:"(fl. 352/963)",
        sortingKey:"(d. 352/963)",
        scholarName:"Aḥmad b. Muḥammad b. Jaʿfar, Abū ʿAlī al-Ṣūlī "
     },
     "35":{
        scholarName:"Abū Bakr Muḥammad b. ʿUmar b. Muḥammad al-Tamīmī, Ibn al-Jiʿābī ",
        death:"(d. 355/966)",
        sortingKey:"(d. 355/966)"
     },
     "36":{
        sortingKey:"(d. 356/967)",
        scholarName:"ʿUbaydullāh b. Aḥmad b. Yaʿqūb b. Naṣr b. Ṭālib, Abū Ṭālib al-Anbārī ",
        death:"(d. 356/967)"
     },
     "37":{
        sortingKey:"(d. 358/968)",
        scholarName:"al-Ḥusayn b. Ḥamdān a-Khaṣībī ",
        death:"(d. 358/968)"
     },
     "38":{
        scholarName:"al-Sharīf al-Ḥasan b. Ḥamza b. ʿAlī al-Ṭabarī al-Marʿashī, Ibn Ḥamza ",
        death:"(d. 358/969)",
        sortingKey:"(d. 358/969)"
     },
     "39":{
        death:"(d. 359/969)",
        sortingKey:"(d. 359/969)",
        scholarName:"Muḥammad b. al-Ḥasan b. al-Qāsim b. al-Ḥasan al-ʿAlawī, Ibn al-Dāʿī "
     },
     "40":{
        sortingKey:"(d. 360/971)",
        scholarName:"Muḥammad b. Ibrāhīm al-Nuʿmānī, Ibn Abī Zaynab ",
        death:"(d. 360/971)"
     },
     "41":{
        death:"(d. 360/971)",
        sortingKey:"(d. 360/971)",
        scholarName:"Abū Aḥmad Muḥammad b. ʿAlī bʿAbdak al-Jurjānī, Ibn ʿAbdak "
     },
     "42":{
        scholarName:"Abū ʿAlī Muḥammad b. Aḥmad b. al-Junayd al-Kātib al-Iskāfī, Ibn al-Junayd al-Iskāfī ",
        death:"(d. between 366-377/977-988)",
        sortingKey:"(d. 366-377/977-988)"
     },
     "43":{
        scholarName:"Muẓaffar b. Muḥammad b. Aḥmad al-Khurāsānī, Abū al-Jaysh al-Balkhī ",
        death:"(d. 367/978)",
        sortingKey:"(d. 367/978)"
     },
     "44":{
        sortingKey:"(d. 368/978)",
        scholarName:"Aḥmad b. Muḥammad, Abū Ghālib al-Zurārī ",
        death:"(d. 368/978)"
     },
     "45":{
        sortingKey:"(d. 368/978)",
        scholarName:"Abū al-Qāsim Jaʿfar b. Muḥammad b. Ja’far b. Mūsā b. Masrūr, Ibn Qūlawayh al-Qummī ",
        death:"(d. 368/978)"
     },
     "46":{
        sortingKey:"(d. 368/978)",
        scholarName:"Abū al-Ḥasan Muḥammad b. Aḥmad b. Dāwūd, Ibn Dāwūd al-Qummī ",
        death:"(d. 368/978)"
     },
     "47":{
        sortingKey:"(d. 375/985)",
        scholarName:"ʿAlī b. Abū al-Ḥasan ʿAlī al-ʿAlawī al-Ḥusaynī, Ibn Aʿlam ",
        death:"(d. 375/985)"
     },
     "48":{
        scholarName:"al-Ḥusayn b. ʿAlī b. al-Ḥusayn b. Mūsā b. Bābawayh al-Qummī, Ibn Bābawayh Abū ʿAbdillāḥ ",
        death:"(fl. 378/988)",
        sortingKey:"(d. 378/988)"
     },
     "49":{
        sortingKey:"(d. 380/990)",
        scholarName:"Abū al-Faraj Muḥammad b. Abī Yaʿqūb Isḥāq b. Muḥammad b. Isḥāq, Ibn al-Nadīm ",
        death:"(d. 380/990)"
     },
     "50":{
        scholarName:"Muḥammad b. ʿAlī b. al-Ḥusayn b. Mūsā b. Bābawayh al-Qummī, al-Shaykh al-Ṣadūq ",
        death:"(d. 381/991)",
        sortingKey:"(d. 381/991)"
     },
     "51":{
        death:"(d. 4th/10th century)",
        sortingKey:"(d. 4th/10th century)",
        scholarName:"al-Ḥasan b. ʿAlī b. al-Ḥusayn b. Shuʿaba al-Ḥarrānī, Ibn Shuʿba al-Ḥarrānī "
     },
     "52":{
        scholarName:"ʿAlī b. Muḥammad b. ʿAlī al-Khazzāz al-Rāzī al-Qummī ",
        death:"(d. 381/991 or 400/ 1009)",
        sortingKey:"(d. 381/991 or 400/ 1009)"
     },
     "53":{
        scholarName:"Abū al-Mufaḍḍal al-Shaybānī ",
        death:"(d. 387/997)",
        sortingKey:"(d. 387/997)"
     },
     "54":{
        sortingKey:"(d. 5th/11th century)",
        scholarName:"Abū al-Ḥasan ʿAlī b. al-Ḥasan b. Abī al-Majd al-Ḥalabī ",
        death:"(d. 5th/11th century)"
     },
     "55":{
        sortingKey:"(d. 4th/10th century)",
        scholarName:"Abū al-Ḥasan ʿAlī b. Ḥammād b. ʿUbaydullāh b. al-Ḥammād al-ʿAbdī al-Baṣrī, Ibn al-Ḥammād ",
        death:"(d. c. 4th/10th century)"
     },
     "56":{
        sortingKey:"(d. 4th/10th-5th/11th century)",
        scholarName:"Abū al-Ḥasan ʿAlī b. Hibatullāh b. ʿUthmān b. Aḥmad b. Ibrāhīm al-Mūṣalī, Ibn Rāʾiqa ",
        death:"(d. 4th/10th-5th/11th century)"
     },
     "57":{
        sortingKey:"(d. 396/1006)",
        scholarName:"Abū al-Ḥasan Aḥmad b. Muḥammad b. ʿImrān (ʿUmar) b. Mūsā b. ʿUrwa b. Jarrāḥ b. ʿAlī b. Zayd b. Bakr b. al-Ḥarīsh al-Nahshalī al-Baghdādī, Ibn Jundī ",
        death:"(d. 396/1006)"
     },
     "58":{
        scholarName:"Abū Aḥmad al-Ḥusayn b. Mūsā al-ʿAlawī ",
        death:"(d. 400/1009)",
        sortingKey:"(d. 400/1009)"
     },
     "60":{
        scholarName:"Establishment of the Buwayhid rule in Iraq (334-403/945-1012)",
        death:"(334/945)",
        color:"#eeddbb",
        sortingKey:"(d. 334/945)"
     },
     "61":{
        scholarName:"End of the Minor Occultation (260-329/874-941)",
        death:"(329/941)",
        color:"#eeddbb",
        sortingKey:"(d. 329/941)"
     },
     "62":{
        sortingKey:"(d. 329/941)",
        scholarName:"Beginning of the Major Occultation (329-contd./941-contd.)",
        death:"(329/941)",
        color:"#eeddbb"
     },
     "101":{
        sortingKey:"(d. 4th/10th century)",
        scholarName:"Muḥammad b. Jarīr b. Rustam al-Ṭabarī",
        death:"(d. c. 4th/10th century)"
     }
  },
  "5":{
     "0":{
        sortingKey:"(d. 5th/11th century)",
        scholarName:"al-Ḥusayn b. ʿAbd al-Wahhāb, Ibn ʿAbd al-Wahhāb ",
        death:"(d. 5th/11th century)"
     },
     "1":{
        sortingKey:"(d. 401/1010)",
        scholarName:"Aḥmad b. Muḥammad b. ʿUbaydullāh al-Jawharī, Ibn ʿAyyāsh al-Jawharī ",
        death:"(d. 401/1010)"
     },
     "2":{
        sortingKey:"(d. 402/1011)",
        scholarName:"Abū al-Ḥasan Muḥammad b. Jaʿfar b. Muḥammad b. Hārūn al-Tamīmī al-Kūfī, Ibn al-Najjār ",
        death:"(d. 402/1011)"
     },
     "3":{
        sortingKey:"(d. 406/1015)",
        scholarName:"Muḥammad b. al-Ḥusayn b. Mūsā, al-Sharīf al-Raḍī, al-Sayyid al-Raḍī ",
        death:"(d. 406/1015)"
     },
     "4":{
        sortingKey:"(d. 408/1017)",
        scholarName:"Abū al-ʿAbbās Aḥmad b. ʿAlī b. Muḥammad b. Aḥmad b. ʿAbbās b. Nūḥ, Ibn Nūḥ al-Sīrāfī ",
        death:"(fl. 408/1017)"
     },
     "5":{
        death:"(d. 411/1020)",
        sortingKey:"(d. 411/1020)",
        scholarName:"al-Ḥusayn b. ʿUbaydullāh al-Ghaḍāʾirī "
     },
     "6":{
        sortingKey:"(d. 413/1022)",
        scholarName:"Muḥammad b. Muḥammad b. al-Nuʿmān al-ʿUkbarī, al-Shaykh al-Mufīd ",
        death:"(d. 413/1022)"
     },
     "7":{
        death:"(d. 419/1028)",
        sortingKey:"(d. 419/1028)",
        scholarName:"Muḥammad b. ʿAbd al-Malik Tabbān "
     },
     "8":{
        death:"(d. 420/1029)",
        sortingKey:"(d. 420/1029)",
        scholarName:"Aḥmad b. Muḥammad al-Rāzī, Miskawayh "
     },
     "9":{
        death:"(d. c. 420/1029)",
        sortingKey:"(d. 420/1029)",
        scholarName:"Muḥammad b. Aḥmad b. ʿAlī b. al-Ḥasan al-Qummī, Ibn Shādhān "
     },
     "10":{
        sortingKey:"(d. 423/1032)",
        scholarName:"Aḥmad b. ʿAbd al-Wāḥid b. Aḥmad al-Bazzāz, Ibn ʿUbdūn, Ibn al-Ḥāshir ",
        death:"(d. 423/1032)"
     },
     "11":{
        sortingKey:"(d. 428/1037)",
        scholarName:"Abū ʿAlī al-Ḥusayn b. ʿAbdullāh b. Sīnā, Abū ʿAlī Sīnā ",
        death:"(d. 428/1037)"
     },
     "12":{
        scholarName:"Abū Saʿīd Manṣūr b. al-Ḥusayn, Wazīr Dhū al-Maʿālī, Zayn al-Kafā ",
        death:"(d. 421/103 or 422/1031 or 432/1040)",
        sortingKey:"(d. 421/103 or 422/1031 or 432/1040)"
     },
     "13":{
        sortingKey:"(d. 436/1044)",
        scholarName:"ʿAlī b. al-Ḥusayn b. Mūsā al-Mūsawī, al-Sharīf al-Murtaḍā, al-Sayyid al-Murtaḍā, ʿAlam al-Hudā ",
        death:"(d. 436/1044)"
     },
     "14":{
        scholarName:"Muḥammad b. Muḥammad b. Aḥmad al-Buṣrawī, Abū al-Ḥasan al-Buṣrawī ",
        death:"(d. 443/1051)",
        sortingKey:"(d. 443/1051)"
     },
     "15":{
        sortingKey:"(d. 446/1054)",
        scholarName:"Abū al-Ṣalāḥ Taqī b. Najm al-Ḥalabī, Abū al-Ṣalāḥ ",
        death:"(d. 446/1054)"
     },
     "16":{
        scholarName:"Taqī al-Dīn b. Najm al-Dīn, Abū al-Ṣalāḥ al-Ḥalabī ",
        death:"(d. 447/1055)",
        sortingKey:"(d. 447/1055)"
     },
     "17":{
        death:"(d. 448/1056 or 463/1071)",
        sortingKey:"(d. 448/1056 or 463/1071)",
        scholarName:"al-Shaykh Abū Yaʿlā Ḥamza b. ʿAbd al-ʿAzīz al-Daylamī, Sallār al-Daylamī "
     },
     "18":{
        scholarName:"Abū al-Fatḥ Muḥammad b. ʿAlī b. ʿUthmān al-Karājakī/al-Karājukī ",
        death:"(d. 449/1057)",
        sortingKey:"(d. 449/1057)"
     },
     "19":{
        sortingKey:"(d. 450/1058)",
        scholarName:"Abū al-ʿAbbās Aḥmad b. ʿAlī b. Aḥmad b. al-ʿAbbās al-Najāshī al-Asadī, Ibn al-Kūfī ",
        death:"(d. 450/1058 or after 463/1070)"
     },
     "20":{
        death:"(d. 450/1058)",
        sortingKey:"(d. 450/1058)",
        scholarName:"Aḥmad b. al-Ḥusayn al-Ghaḍāʾirī al-Wāsiṭī al-Baghdādī, Ibn al-Ghaḍāʾirī "
     },
     "21":{
        sortingKey:"(d. 458/1065)",
        scholarName:"Bahmanyār b. Marzbān ",
        death:"(d. 458/1065)"
     },
     "22":{
        death:"(d. 460/1067)",
        sortingKey:"(d. 460/1067)",
        scholarName:"Abū Jaʿfar Muḥammad b. al-Ḥasan b. ʿAlī b. al-Ḥasan al-Ṭūsī, al-Shaykh al-Ṭūsī "
     },
     "23":{
        death:"(d. c. 460/1067)",
        sortingKey:"(d. 460/1067)",
        scholarName:"Najm al-Dīn Abū al-Ḥasan ʿAlī b. Abū al-Ghanāʾim al-ʿAlawī al-ʿUmarī, Ibn al-Ṣūfī "
     },
     "24":{
        scholarName:"Abū Yaʿlā Muḥammad b. al-Ḥasan b. Ḥamzā al-Jaʿfarī, Abū Yaʿlā al-Jaʿfarī ",
        death:"(d. 463/1070)",
        sortingKey:"(d. 463/1070)"
     },
     "25":{
        sortingKey:"(d. 463-583/1070-1188)",
        scholarName:"ʿImād al-Dīn Abū Jaʿfar Muḥammad b. ʿAlī b. Ḥamza al-Ṭūsī, Ibn Ḥamza al-Ṭūsī ",
        death:"(d. between 463-583/1070-1188)"
     },
     "26":{
        death:"(d. c. 473/1080)",
        sortingKey:"(d. 473/1080)",
        scholarName:"Jaʿfar b. Muḥammad b. Aḥmad al-Rāzī al-Dūryastī "
     },
     "27":{
        sortingKey:"(d. 481/1088)",
        scholarName:"al-Qāḍī Abū al-Qāsim ʿAbd al-ʿAzīz b. Naḥrīr b. ʿAbd al-ʿAzīz Ibn al-Barrāj al-Ṭarāblusī ",
        death:"(d. 481/1088)"
     },
     "28":{
        death:"(d. c. 494/1100)",
        sortingKey:"(d. 494/1100)",
        scholarName:"Abū al-Mufaḍḍal Asʿad b. Aḥmad al-Ṭarāblūsī "
     },
     "32":{
        scholarName:"End of the Buwayhid rule in Iraq (334-403/945-1012)",
        death:"(403/1012)",
        color:"#eeddbb",
        sortingKey:"(d. 403/1012)"
     },
     "33":{
        scholarName:"Seljuk conquest of Baghdad",
        death:"(447/1055)",
        color:"#eeddbb",
        sortingKey:"(d. 447/1055)"
     },
     "202":{
        sortingKey:"(d. 435/1043)",
        scholarName:"Shaykh al-Sharaf ʿAbīdalī Ibn Abī Jaʿfar",
        death:"(d. 435/1043)"
     },
     "203":{
        sortingKey:"(d. 418/1027)",
        scholarName:"Abū al-Qāsim al-Ḥusayn b. ʿAlī al-Maghribī, Ibn al-Maghribī, Wazīr al-Maghribī ",
        death:"(d. 418/1027)"
     },
     "204":{
        sortingKey:"(d. 426/1034 or 427/1035)",
        scholarName:"Abū Saʿīd Maymūn b. al-Qāsim al-Ṭabarānī",
        death:"(d. 426/1034 or 427/1035)"
     }
  },
  "6":{
     "0":{
        death:"(d. after 503/1110)",
        sortingKey:"(d. 503/1110)",
        scholarName:"Abū al-Wafāʾ ʿAbd al-Jabbār b. ʿAbd Allāh b. ʿAlī al-Rāzī "
     },
     "1":{
        death:"(d. 508/1115)",
        sortingKey:"(d. 508/1115)",
        scholarName:"al-Shaykh Abū ʿAlī Muḥammad b. al-Ḥasan b. ʿAli b. Aḥmad b. al-Fattāl al-Nayshāpurī al-Farisī, Ibn al-Fattāl al-Nayshāpurī "
     },
     "2":{
        sortingKey:"(d. 510/1116 or 520/1126 or 550/1155)",
        scholarName:"Abū al-Fatḥ Nāṣiḥ al-Dīn ʿAbd al-Wāḥid b. Muḥammad al-Āmīdī ",
        death:"(d. 510/1116 or 520/1126 or 550/1155)"
     },
     "3":{
        sortingKey:"(d. 511/1117)",
        scholarName:"al-Ḥasan b. Muḥammad b. al-Ḥasan al-Ṭūsī, Abū ʿAlī al-Ṭūsī, al-Mufīd al-Thānī ",
        death:"(d. after 511/1117)"
     },
     "4":{
        scholarName:"Abū al-Ḥasan ʿAlī b. Aḥmad al-Fanjkirdī al-Nayshābūrī ",
        death:"(d. c. 513/1119)",
        sortingKey:"(d. 513/1119)"
     },
     "5":{
        death:"(d. 548/1153)",
        sortingKey:"(d. 548/1153)",
        scholarName:"al-Faḍl b. al-Ḥasan al-Ṭabrisī, Amīn al-Islām, author of Majmaʿ al-bayān"
     },
     "6":{
        sortingKey:"(d. 6th/12th century)",
        scholarName:"al-Ḥasan b. Faḍl al-Ṭabrisī, author of Makārim al-akhlāq ",
        death:"(d. 6th/12th century)"
     },
     "7":{
        death:"(d. second half of the 6th/12th century)",
        sortingKey:"(d. 551/1156)",
        scholarName:"ʿAbdul Jalīl b. Abū al-Ḥusayn b. Abū al-Faḍl al-Qazwīnī al-Rāzī "
     },
     "8":{
        death:"(d. after 551/1121)",
        sortingKey:"(d. 551/1121)",
        scholarName:"Abū ʿAlī al-Ḥasan b. Muḥammad b. al-Ḥasan al-Ṭūsī "
     },
     "9":{
        death:"(d. 552/1157 or 556/1161)",
        sortingKey:"(d. 552/1157 or 556/1161)",
        scholarName:"Jamāl al-Dīn al-Ḥusayn b. ʿAlī al-Nayshābūrī al-Rāzī, Abū al-Futūḥ al-Rāzī "
     },
     "10":{
        scholarName:"Muḥammad b. ʿAlī al-Ṭabarī, ʿImād al-Dīn al-Ṭabarī ",
        death:"(d. 553/1158)",
        sortingKey:"(d. 553/1158)"
     },
     "11":{
        sortingKey:"(d. 567/1171)",
        scholarName:"al-Ḥāfiẓ al-Shaykh Abī Muḥammad ʿAbdullāh b. al-Naṣr, Ibn al-Khashshāb al-Baghdādī ",
        death:"(d. 567/1171)"
     },
     "12":{
        death:"(d. 573/1177)",
        sortingKey:"(d. 573/1177)",
        scholarName:"Quṭb al-Dīn Abū al-Ḥusayn Saʿīd b. ʿAbdullāh al-Rāwandī, al-Quṭb al-Rāwandī "
     },
     "13":{
        sortingKey:"(d. 585/1189)",
        scholarName:"al-Sayyid ʿIzz al-Dīn Abū al-Makārim Ḥamza b. ʿAlī b. Zuhra al-Ḥusaynī al-Ḥalabī, Ibn Zuhra al-Ḥalabī ",
        death:"(d. 585/1189)"
     },
     "14":{
        sortingKey:"(d. 585/1189)",
        scholarName:"ʿAlī b. ʿUbaydullāh al-Rāzī, al-Shaykh Muntajab al-Dīn al-Rāzī ",
        death:"(d. c. 585/1189)"
     },
     "15":{
        sortingKey:"(d. 588/1192)",
        scholarName:"Muḥammad b. ʿAlī Ibn Shahrāshūb al-Sarawī al-Māzandarānī, Ibn Shahrāshūb ",
        death:"(d. 588/1192)"
     },
     "16":{
        sortingKey:"(d. 588/1192)",
        scholarName:"Abū Manṣūr Aḥmad b. ʿAlī b. Abū Ṭālib al-Ṭabrisī, author of al-Iḥtijāj ",
        death:"(d. 588/1192)"
     },
     "17":{
        scholarName:"Abū ʿAbdillāh Muḥammad b. Muḥammad b. Hārūn al-Bazzāz al-Ḥillī, Ibn Kāl ",
        death:"(d. 597/1201)",
        sortingKey:"(d. 597/1201)"
     },
     "18":{
        sortingKey:"(d. 598/1201)",
        scholarName:"Muḥammad b. Manṣūr b. Aḥmad b. Idrīs al-Ḥillī al-ʿIjlī, Ibn Idrīs al-Ḥillī ",
        death:"(d. c. 598/1201)"
     },
     "19":{
        death:"(d. 6th/12th century)",
        sortingKey:"(d. 6th/12th century)",
        scholarName:"Imād al-Dīn Dhū al-Fiqār b. Muḥammad b. Maʿbad al-Ḥasanī, Abū al-Ṣamṣām al-Mirwazī "
     },
     "21":{
        death:"(d. c. 600/1203)",
        sortingKey:"(d. 600/1203)",
        scholarName:"ʿAlī b. al-Ḥasan al-Ṭabrisī, author of Mishkāt al-anwār "
     },
     "22":{
        death:"(d. 600/1203)",
        sortingKey:"(d. 600/1203)",
        scholarName:"Yaḥyā b. al-Ḥasan b. al-Ḥusayn b. ʿAlī b. Muḥammad b. Biṭrīq al-Ḥillī al-Asadī al-Ribʿī, Ibn Biṭrīq "
     },
     "101":{
        scholarName:"Ḍiyāʾ al-Dīn Abū al-Riḍā Faḍlallāh b. ʿAlī b. ʿAbdallāh al-Ḥasanī al-Rāwandī al-Qāsānī, Faḍlallāh al-Rāwandī",
        death:"(d. 551/1165)",
        sortingKey:"(d. 551/1165)"
     },
     "102":{
        sortingKey:"(d. 544/1149)",
        scholarName:"Nuṣrat al-Dīn Abū Muḥammad al-Ḥasan b. ʿAlī b. Zīrak al-Qummī",
        death:"(fl. 544/1149)"
     },
     "103":{
        scholarName:"Hāshim b. Muḥammad ʿAlī ",
        death:"(fl. 558/1162)",
        sortingKey:"(d. 558/1162)"
     },
     "104":{
        death:"(d. 582/1186)",
        sortingKey:"(d. 582/1186)",
        scholarName:"Najīb al-Dīn Abū al-Qāsim ʿAbd al-Raḥmān b. ʿAlī b. Muḥammad al-Ḥusaynī "
     }
  },
  "7":{
     "1":{
        scholarName:"al-Sahaykh Abū al-Ḥusayn Warrām b. Abī Firās ʿĪsā b. Abī al-Najm b. Ḥamdān b. Khawalān al-Ḥillī ",
        death:"(d. 605/1208)",
        sortingKey:"(d. 605/1208)"
     },
     "2":{
        death:"(d. 610/1213)",
        sortingKey:"(d. 610/1213)",
        scholarName:"Abū ʿAbdillāh Muḥammad b. Jaʿfar b. ʿAlī al-Mashhadī al-Ḥāʾirī, Muḥammad b. al-Mashhadī, Ibn al-Mashhadī "
     },
     "3":{
        scholarName:"Saʿd al-Dīn Mūsā ",
        death:"(d. c. 620/1223)",
        sortingKey:"(d. 620/1223)"
     },
     "4":{
        sortingKey:"(d. 603/1206)",
        scholarName:"al-Sayyid Shams al-Dīn Abū ʿAlī Fikhār b. Maʿad al-Musawī ",
        death:"(d. 603/1206)"
     },
     "5":{
        sortingKey:"(d. 620/1223)",
        scholarName:"Muḥammad b. Isḥāq, Ṭāwūs ",
        death:"(d. 620/1223)"
     },
     "6":{
        sortingKey:"(d. 626/1229)",
        scholarName:"ʿIzz al-Dīn Ismāʿīl b. Ḥusayn b. Muḥammad, Abū Ṭālib al-Marwazī ",
        death:"(d. before 626/1229)"
     },
     "7":{
        death:"(d. after 635/1238)",
        sortingKey:"(d. 635/1238)",
        scholarName:"Asʿad b. ʿAbd al-Qāhir b. Asʿad, Abū al-Saʿādāt al-Iṣfahānī "
     },
     "8":{
        sortingKey:"(d. 645/1247 or 680/1281)",
        scholarName:"Najm al-Dīn Jaʿfar b. Muḥammad al-Ḥillī, Ibn Numā al-Ḥillī ",
        death:"(d. 645/1247 or 680/1281)"
     },
     "9":{
        sortingKey:"(d. 654/1256)",
        scholarName:"ʿIzz al-Dīn al-Ḥasan ",
        death:"(d. 654/1256)"
     },
     "10":{
        scholarName:"Raḍī al-Dīn Muḥammad b. Muḥammad b. Zayd b. al-Dāʿī al-Ḥusaynī ",
        death:"(d. 654/1256)",
        sortingKey:"(d. 654/1256)"
     },
     "11":{
        sortingKey:"(d. 656/1258)",
        scholarName:"Sharaf al-Dīn Muḥammad ",
        death:"(d. 656/1258)"
     },
     "12":{
        scholarName:"ʿIzz al-Dīn b. Maʿqil al-Muhallabī al-Ḥimṣī ",
        death:"(d. 644/1246)",
        sortingKey:"(d. 644/1246)"
     },
     "14":{
        sortingKey:"(d. 660/1262)",
        scholarName:"Abū al-Faḍl Shādhān b. Jabrāʾīl b. Ismāʿīl b. Abī Ṭālib al-Qummī ",
        death:"(d. 660/1262)"
     },
     "15":{
        sortingKey:"(d. 664/1266)",
        scholarName:"Raḍī al-Dīn Alī b. Mūsā b. Jaʿfar b. Ṭāwūs, al-Sayyid Ibn Ṭāwūs ",
        death:"(d. 664/1266)"
     },
     "16":{
        scholarName:"Abū al-Ḥasan, Jamāl al-Dīn/Kamāl al-Dīn, ʿAlī b. Sulaymān al-Satrāwī al-Baḥrānī, Abū al-Ḥasan al-Baḥrānī ",
        death:"(d. 7th/13th century)",
        sortingKey:"(d. 7th/13th century)"
     },
     "17":{
        scholarName:"Khwāja Naṣīr al-Dīn al-Ṭūsī ",
        death:"(d. 672/1274)",
        sortingKey:"(d. 672/1274)"
     },
     "18":{
        scholarName:"ʿIzz al-Dīn al-Ḥasan al-Yūsufī, al-Fāḍil al-Ābī ",
        death:"(fl. 672/1274)",
        sortingKey:"(d. 672/1274)"
     },
     "19":{
        sortingKey:"(d. 673/1274)",
        scholarName:"Jamāl al-Dīn Aḥmad b. Mūsā b. Jaʿfar b. Muḥammad b. Aḥmad b. Muḥammad b. Muḥammad Ibn Ṭāwūs al-ʿAlawī al-Ḥasanī al-Ḥillī ",
        death:"(d. 673/1274)"
     },
     "20":{
        scholarName:"Abū al-Qāsim Najm al-Dīn Jaʿfar b. al-Ḥasan b. Yaḥyā b. Saʿīd al-Ḥillī, al-Muḥaqqiq al-Ḥillī ",
        death:"(d. 676/1277)",
        sortingKey:"(d. 676/1277)"
     },
     "21":{
        sortingKey:"(d. 676/1277) ",
        scholarName:"Mūfid al-Dīn Abū ʿAbdillāh Muḥammad b. ʿAlī al-Asadī al-Ḥillī, Ibn Juhaym ",
        death:"(d. c. 676/1277)"
     },
     "22":{
        sortingKey:"(d. 676/1277)",
        scholarName:"Jamāl al-Dīn Yūsuf b. Ḥātam al-Shāmī al-ʿĀmilī ",
        death:"(d. 676/1277)"
     },
     "23":{
        death:"(d. 679/1280 or 699/1300)",
        sortingKey:"(d. 679/1280 or 699/1300)",
        scholarName:"Kamāl al-Dīn Maytham b. ʿAlī b. Maytham al-Baḥrānī "
     },
     "24":{
        death:"(d. after 688/1289)",
        sortingKey:"(d. 688/1289)",
        scholarName:"Raḍī al-Dīn Muḥammad b. al-Ḥasan al-Astarābādī, al-Fāḍil al-Raḍī, al--Shāriḥ al-Raḍī "
     },
     "25":{
        sortingKey:"(d. 690/1290 or 698/1298)",
        scholarName:"Yaḥyā b. Saʿīd al-Ḥillī ",
        death:"(d. 690/1290 or 698/1298)"
     },
     "26":{
        death:"(d. 692/1293 or 693/1294)",
        sortingKey:"(d. 692/1293 or 693/1294)",
        scholarName:"Abū al-Ḥasan ʿAlī b. ʿĪsā al-Hakkārī Bahāʾ al-Dīn al-Irbilī "
     },
     "27":{
        sortingKey:"(d. 693/1293)",
        scholarName:"al-Sayyid Ghiyāth al-Dīn ʿAbd al-Karīm b. Aḥmad b. Mūsā b. Ṭāwūs al-Ḥillī ",
        death:"(d. 693/1293)"
     },
     "28":{
        scholarName:"Rukn al-Dīn Muḥammad b. ʿAlī b. Muḥammad al-Astarābādī, al-Jurjānī ",
        death:"(fl. 697/1297)",
        sortingKey:"(d. 697/1297)"
     },
     "29":{
        scholarName:"Najm al-Dīn al-Baʿlabakkī ",
        death:"(d. 699/1300)",
        sortingKey:"(d. 699/1300)"
     },
     "33":{
        death:"(654/1256)",
        color:"#eeddbb",
        sortingKey:"(d. 654/1256)",
        scholarName:"Beginning of the Ilkhanid rule in Iran (654-754/1256-1353)"
     },
     "35":{
        sortingKey:"(d. 648/1250)",
        scholarName:"Beginning of the Mamlūk sultanate in Egypt (648-922/1250-1517)",
        death:"(648/1250)",
        color:"#eeddbb"
     },
     "101":{
        death:"(d. 7th/13th century)",
        sortingKey:"(d. 7th/13th century)",
        scholarName:"al-Shaykh ʿAlī b. Muḥammd b. Muḥammad al-Qummī al-Sabzawārī"
     },
     "105":{
        sortingKey:"(d. 683/1284)",
        scholarName:"ʿIzz al-Dawla Saʿd b. Manṣūr al-Baghdādī, Ibn Kammūna",
        death:"(d. 683/1284)"
     },
     "106":{
        scholarName:"al-Shaykh Shams al-Dīn Muḥammad b. Aḥmad b. Ṣāliḥ al-Sībī al-Qasīnī",
        death:"(d. before 700/1300)",
        sortingKey:"(d. 700/1300)"
     },
     "107":{
        death:"(d. 630/1232)",
        sortingKey:"(d. 630/1232)",
        scholarName:"al-Sayyid Shams al-Dīn Abū ʿAlī Fakhkhār b. Maʿd b. Fakhkhār al-ʿAlawī al-Musawī al-Ḥāʿirī"
     },
     "108":{
        scholarName:"Muḥammad b. ʿAlī b. Muḥammad b. Juhaym al-Asadī al-Rabʿī, Abū Jaʿfar al-Ḥillī, Ibn Juhamym, Mufīd al-Dīn",
        death:"(d. 680/1281)",
        sortingKey:"(d. 680/1281)"
     },
     "232":{
        death:"(656/1258)",
        color:"#eeddbb",
        sortingKey:"(d. 656/1258)",
        scholarName:"End of the ʿAbbāsid caliphate (132-656/750-1258)"
     },
     "298":{
        sortingKey:"(d. 698/1299)",
        scholarName:"Establishment of the Ottoman Empire (c. 698-1341/1299-1923)",
        death:"(c. 698/1299)",
        color:"#eeddbb"
     },
     "345":{
        sortingKey:"(d. 658/1260)",
        scholarName:"Beginning of the Mamlūk sultanate in Syria (658-922/1260-1516)",
        color:"#eeddbb",
        death:"(658/1260)"
     }
  },
  "8":{
     "0":{
        death:"(d. 8th/14th century)",
        sortingKey:"(d. 8th/14th century)",
        scholarName:"al-Ḥasan b. Muḥammad al-Daylamī "
     },
     "1":{
        sortingKey:"(d. 703/1303)",
        scholarName:"ʿAlī b. Yūsuf b. al-Muṭahhar al-Ḥillī ",
        death:"(fl. 703/1303)"
     },
     "2":{
        scholarName:"Abū Muḥammad Taqī al-Dīn al-Ḥasan b. ʿAlī b. Dāwūd al-Ḥillī ",
        death:"(d. after 707/1307)",
        sortingKey:"(d. 707/1307)"
     },
     "3":{
        sortingKey:"(d. 716/1316)",
        scholarName:"Sulaymān b. ʿAbd al-Qawī al-Ṭūfī ",
        death:"(d. 716/1316)"
     },
     "4":{
        death:"(d. 721/1321)",
        sortingKey:"(d. 721/1321)",
        scholarName:"Muḥammad b. Abī Bakr al-Sakākīnī "
     },
     "5":{
        sortingKey:"(d. 726/1325)",
        scholarName:"Abū Manṣūr Jamāl al-Dīn al-Ḥasan b. Yūsuf b. al-Muṭahhar al-Ḥillī, al-ʿAllāma al-Ḥillī ",
        death:"(d. 726/1325)"
     },
     "6":{
        death:"(d. 749/1348)",
        sortingKey:"(d. 749/1348)",
        scholarName:"ʿAlā al-Dīn Muḥammad b. Aḥmad al-Bayhaqī al-Isfarāyinī, Fakhr-i al-Khurāsānī "
     },
     "7":{
        scholarName:"Abū Saʿīd/Abū ʿAlī al-Ḥasan b. al-Ḥusayn al-Wāʿiẓ al-Bayhaqī ",
        death:"(fl. 753/1352)",
        sortingKey:"(d. 753/1352)"
     },
     "8":{
        sortingKey:"(d. 753/1352)",
        scholarName:"al-Sayyid al-Sharīf Tāj al-Dīn b. Muḥammad b. Ḥamza b. Zuhra al-Ḥusaynī al-Fūʾī al-Nassāba ",
        death:"(fl. 753/1352)"
     },
     "9":{
        scholarName:"al-Sayyid ʿAmīd al-Dīn b. ʿAbdul Muṭṭalib b. Majd al-Dīn b. Abī al-Fawāris al-Aʿrajī ",
        death:"(d. 754/1353)",
        sortingKey:"(d. 754/1353)"
     },
     "10":{
        death:"(d. 766/1365)",
        sortingKey:"(d. 766/1365)",
        scholarName:"Muḥammad b. Maḥmūd Būyihʾī al-Rāzī al-Warāmīnī, Qutb al-Dīn al-Rāzī "
     },
     "11":{
        scholarName:"Masʿūd b. ʿAbdullāh al-Bayḍāwī, Bāba Rukn al-Dīn al-Shīrāzī ",
        death:"(d. 769/1368)",
        sortingKey:"(d. 769/1368)"
     },
     "12":{
        scholarName:"Muḥammad b. al-Ḥasan b. Yūsuf b. ʿAlī b. al-Muṭṭahar al-Ḥillī, Fakhr al-Muḥaqqiqīn ",
        death:"(d. 771/1369)",
        sortingKey:"(d. 771/1369)"
     },
     "13":{
        death:"(d. 786/1386)",
        sortingKey:"(d. 786/1386)",
        scholarName:"Abū ʿAbdillāh Shams al-Dīn Muḥammad b. al-Makkī al-ʿĀmilī al-Jizzīnī, al-Shahīd al-Awwal "
     },
     "14":{
        sortingKey:"(d. 787/1385)",
        scholarName:"al-Sayyid Ḥaydar al-Āmūlī ",
        death:"(fl. 787/1385)"
     },
     "16":{
        sortingKey:"(d. 796-798/1393-1395)",
        scholarName:"Faḍlullāh al-Naʿīmī al-Astarābādī ",
        death:"(d. 796-798/1393-1395)"
     },
     "19":{
        death:"(754/1353)",
        color:"#eeddbb",
        sortingKey:"(d. 754/1353)",
        scholarName:"End of the Ilkhanid rule in Iran (654-754/1256-1353)"
     },
     "20":{
        sortingKey:"(d. 736/1335)",
        scholarName:"Beginning of the Sarabdārān movement (736-788/1335-1386)",
        death:"(736/1335)",
        color:"#eeddbb"
     },
     "21":{
        sortingKey:"(d. 788/1386)",
        scholarName:"End of the Sarabdārān movement (736-788/1335-1386)",
        death:"(788/1386)",
        color:"#eeddbb"
     },
     "22":{
        scholarName:"Beginning of the Timurid/Gurkani rule (771-913/1370-1507)",
        death:"(771/1370)",
        color:"#eeddbb",
        sortingKey:"(d. 771/1370)"
     },
     "108":{
        death:"(d. 736/1335)",
        sortingKey:"(d. 736/1335)",
        scholarName:"al-Shaykh Khalīfa al-Māzandarānī"
     },
     "109":{
        scholarName:"al-Shaykh Ḥasan Jūrī",
        death:"(d. 8th/14th century)",
        sortingKey:"(d. 8th/14th century)"
     },
     "110":{
        death:"(d. 711/1311)",
        sortingKey:"(d. 711/1311)",
        scholarName:"ʿAlī b. ʿAlī b. Ṭāwūs"
     }
  },
  "9":{
     "0":{
        sortingKey:"(d. 802/1399)",
        scholarName:"ʿIzz al-Dīn Abū Muḥammad al-Ḥasan b. Sulaymān b. Muḥammad b. Khālid al-Ḥillī al-ʿĀmilī",
        death:"(d. after 802/1399)"
     },
     "1":{
        sortingKey:"(d. 803/1400)",
        scholarName:"al-Sayyid Bahāʾ al-Dīn ʿAlī b. ʿAbd al-Karīm al-Naylī al-Najafī ",
        death:"(fl. 803/1400)"
     },
     "2":{
        scholarName:"Ḥāfiẓ Rajab Bursī ",
        death:"(d. after 813/1410)",
        sortingKey:"(d. 813/1410)"
     },
     "3":{
        sortingKey:"(d. 820/1216)",
        scholarName:"Jamāl al-Dīn b. ʿAbdullāh al-Baḥrānī, Ibn al-Mutawwaj ",
        death:"(d. 820/1216)"
     },
     "4":{
        death:"(d. 826/1422)",
        sortingKey:"(d. 826/1422)",
        scholarName:"Miqdād b. ʿAbdullāh b. Muḥammad al-Ḥillī al-Suyūrī, al-Fāḍil Miqdād al-Suyūrī "
     },
     "5":{
        scholarName:"al-Sayyid Jamāl al-Dīn Aḥmad b. ʿAlī b. al-Ḥusayn al-Ḥasanī al-Ḥusaynī, Ibn ʿInaba ",
        death:"(d. 828/1424)",
        sortingKey:"(d. 828/1424)"
     },
     "6":{
        sortingKey:"(d. 835/1432)",
        scholarName:"Ṣāʾin al-Dīn ʿAlī b. Muḥammad b. Afḍal al-Dīn Muḥammad Turka al-Khujandī al-Iṣfahānī, Ibn Turka ",
        death:"(d. 835/1432)"
     },
     "7":{
        scholarName:"Aḥmad b. Muḥammad b. Fahd al- Ḥillī, Ibn Fahd al-Ḥillī ",
        death:"(d. 841/1437)",
        sortingKey:"(d. 841/1437)"
     },
     "8":{
        sortingKey:"(d. 850/1446)",
        scholarName:"Khiḍr b. Muḥammad al-Ḥablārūdī, Najm al-Dīn ",
        death:"(d. c. 850/1446)"
     },
     "9":{
        scholarName:"Zayn al-Dīn ʿAlī b. ʿAlī b. Muḥammad b. Ṭayy al-Faqʿānī ",
        death:"(d. 855/1451)",
        sortingKey:"(d. 855/1451)"
     },
     "10":{
        sortingKey:"(d. 877/1472)",
        scholarName:"ʿAlī b. Muḥammad b. Yūnus al-Nabāṭī al-Bayāḍī al-Baqāʿī ",
        death:"(d. 877/1472)"
     },
     "11":{
        sortingKey:"(d. 879/1474)",
        scholarName:"ʿAlāʾ al-Dīn ʿAlī b. Muḥammad al-Qūshchī ",
        death:"(d. 879/1474)"
     },
     "12":{
        scholarName:"Taqī al-Dīn Ibrāhīm b. ʿAlī al-Ḥārithī al-Kafʿamī ",
        death:"(d. 900/1494) ",
        sortingKey:"(d. 900/1494) "
     },
     "110":{
        sortingKey:"(d. 840/1436)",
        scholarName:"al-Shaykh Ṣāliḥ b. ʿAbd al-Wahhāb b. ʿArandas al-Ḥillī, Ibn al- ʿArandas al-Ḥillī",
        death:"(d. 840/1436)"
     }
  },
  "10":{
     "0":{
        scholarName:"Ṣadr al-Dīn Muḥammad b. Ibrāhīm al-Ḥusaynī al-Dashtakī al-Shīrāzī, Ṣadr al-Dīn Dashtakī, al-Sayyid Sanad ",
        death:"(d. 903/1498)",
        sortingKey:"(d. 903/1498)"
     },
     "1":{
        sortingKey:"(d. 904/1499)",
        scholarName:"ʿIzz al-Dīn b. Jaʿfar b. Shams al-Dīn al-Āmūlī, ʿIzz al-Dīn al-Āmūlī ",
        death:"(d. 904/1499)"
     },
     "2":{
        scholarName:"Muḥammad b. Zayn al-Dīn ʿAlī b. Ibrāhīm b. al-Ḥasan b. Ibrāhīm b. Abī Jumhūr al-Aḥsāʾī, Laḥaḍāwī ",
        death:"(fl. 906/1501)",
        sortingKey:"(d. 906/1501)"
     },
     "3":{
        sortingKey:"(d. 904/1498 or 910/1504 or 911/1505)",
        scholarName:"al-Ḥusayn b. Muʿīn al-Dīn ʿAlī al-Maybudī al-Yazdī, Kamāl al-Dīn, al-Manṭiqī, Mīr Ḥusayn Maybudī ",
        death:"(d. 904/1498 or 910/1504 or 911/1505)"
     },
     "4":{
        scholarName:"Taqī al-Dīn Ibrāhīm b. ʿAlī al-ʿĀmilī al-Kafʿamī ",
        death:"(d. 905/1499)",
        sortingKey:"(d. 905/1499)"
     },
     "5":{
        sortingKey:"(d. 908/1502)",
        scholarName:"Jalāl al-Dīn al-Dawānī, al-Muḥaqqiq al-Dawānī ",
        death:"(d. 908/1502)"
     },
     "6":{
        scholarName:"Mulla Ḥusayn al-Wāʿiẓī al-Kāshifī ",
        death:"(d. 910/1504)",
        sortingKey:"(d. 910/1504)"
     },
     "7":{
        sortingKey:"(d. 917/1512)",
        scholarName:"ʿIzz al-Dīn Ḥusayn b. Musāʿid al-Ḥusaynī al-Ḥāʾirī ",
        death:"(d. after 917/1512)"
     },
     "8":{
        sortingKey:"(d. 920/1515)",
        scholarName:"Nūr al-Dīn ʿAlī b. ʿAbd al-ʿĀlī ",
        death:"(d. 920/1515)"
     },
     "9":{
        sortingKey:"(d. 931/1524)",
        scholarName:"Mīr Jamāl al-Dīn Muḥammad al-Astarābādī ",
        death:"(d. 931/1524)"
     },
     "10":{
        sortingKey:"(d. 937/1531)",
        scholarName:"ʿAli b. Hilāl al-Jazāʾirī ",
        death:"(d. 937/1531)"
     },
     "11":{
        sortingKey:"(d. 938/1532)",
        scholarName:"Muḥammad b. Isḥāq al-Ḥamawī, Fāḍil al-Dīn ",
        death:"(fl. 938/1532)"
     },
     "12":{
        death:"(d. 940/1534)",
        sortingKey:"(d. 940/1534)",
        scholarName:"ʿAlī b. al-Ḥusayn b. ʿAbd al-ʿAli al-Karakī al-Jabal ʿĀmilī, al-Muḥaqqiq al-Karakī, al-Muḥaqqiq al-Thānī "
     },
     "13":{
        sortingKey:"(d. 940-949/1533-1542)",
        scholarName:"Ghiyāth al-Dīn Manṣūr al-Dashtakī ",
        death:"(d. between 940-949/1533-1542)"
     },
     "14":{
        scholarName:"Shams al-Dīn Muḥammad b. Aḥmad al-Khafrī ",
        death:"(d. 942/1535  or 957/1550)",
        sortingKey:"(d. 942/1535  or 957/1550)"
     },
     "15":{
        death:"(d. 948/1541)",
        sortingKey:"(d. 948/1541)",
        scholarName:"Najm al-Dīn Maḥmūd al-Nayrīzī "
     },
     "16":{
        death:"(d. 950/1543)",
        sortingKey:"(d. 950/1543)",
        scholarName:"al-Shaykh Ibrāhīm b. Sulaymān, al-Fāḍil al-Qaṭīfī al-Baḥrānī al-Ḥillī "
     },
     "17":{
        sortingKey:"(d. 950/1543)",
        scholarName:"Jalāl al-Dīn al-Ḥusayn b. Sharaf al-Dīn ʿAbd al-Ḥaqq al-Ardabīlī, Ḥusayn Ilāhī al-Ardabīlī ",
        death:"(d. c. 950/1543)"
     },
     "18":{
        sortingKey:"(d. 957/1550 or 999/1590)",
        scholarName:"Mawlānā Muḥammad b. Khwāja Zayn al-Dīn ʿAlī b. Jamāl al-Dīn al-Shīrāzī, Jamāl al-Dīn al-Shīrāzī, ʿUrfī ",
        death:"(d. c. 957/1550 or 999/1590)"
     },
     "19":{
        sortingKey:"(d. 965/1557)",
        scholarName:"Sharaf al-Dīn ʿAli al-Ḥusaynī al-Astarābādī al-Najafī ",
        death:"(d. 965/1557)"
     },
     "20":{
        death:"(d. 965/1557 or 966/1558)",
        sortingKey:"(d. 965/1557 or 966/1558)",
        scholarName:"Zayn al-Dīn b. ʿAlī b. Aḥmad al-ʿĀmilī, al-Shahīd al-Thānī "
     },
     "21":{
        scholarName:"ʿAlī b. Aḥmad, Abū al-Ḥasan Abīwardī ",
        death:"(d. 966/1558)",
        sortingKey:"(d. 966/1558)"
     },
     "23":{
        sortingKey:"(d. 981/1573)",
        scholarName:"ʿAbdullāh b. al-Ḥusayn al-Yazdī ",
        death:"(d. 981/1573)"
     },
     "24":{
        death:"(d. 984/1576)",
        sortingKey:"(d. 984/1576)",
        scholarName:"al-Ḥusayn b. ʿAbd al-Ṣamad al-ʿĀmilī al-Ḥārithī "
     },
     "25":{
        death:"(d. 984/1576)",
        sortingKey:"(d. 984/1576)",
        scholarName:"ʿAlī b. Hilāl al-Karakī, al-Shaykh ʿAlī Minshār "
     },
     "26":{
        scholarName:"Mullā Fatḥullāh al-Kāshānī ",
        death:"(d. 988/1581)",
        sortingKey:"(d. 988/1581)"
     },
     "27":{
        sortingKey:"(d. 993/1585)",
        scholarName:"Aḥmad b. Muḥammad al-Ardabīlī, al-Muqaddas al-Ardabīlī",
        death:"(d. 993/1585)"
     },
     "28":{
        death:"(d. 993/1585)",
        sortingKey:"(d. 993/1585)",
        scholarName:"al-Shaykh Mājid b. Falāḥ, al-Fāḍil al-Shaybānī "
     },
     "29":{
        scholarName:"Kamāl al-Dīn ʿAlī Muḥtasham al-Kāshānī ",
        death:"(d. 996/1588)",
        sortingKey:"(d. 996/1588)"
     },
     "30":{
        scholarName:"End of the Mamlūk sultanate in Syria (658-922/1260-1516)",
        death:"(922/1516)",
        color:"#eeddbb",
        sortingKey:"(d. 922/1516)"
     },
     "222":{
        sortingKey:"(d. 932/1526)",
        scholarName:"Establishment of the Mughal Empire (932-1274/1526-1858)",
        death:"(932/1526)",
        color:"#eeddbb"
     },
     "234":{
        death:"(922/1517)",
        color:"#eeddbb",
        sortingKey:"(d. 922/1517)",
        scholarName:"End of the Mamlūk sultanate in Egypt (648-922/1250-1517)"
     },
     "277":{
        sortingKey:"(d. 913/1507)",
        scholarName:"End of the Timurid dynasty/Gurkani (771-913/1370-1507)",
        death:"(913/1507)",
        color:"#eeddbb"
     },
     "299":{
        death:"(907/1502) ",
        color:"#eeddbb",
        sortingKey:"(d. 907/1502) ",
        scholarName:"Beginning of the Safavid rule (907-1135/1502-1722) "
     }
  },
  "11":{
     "0":{
        sortingKey:"(d. 1001/1592)",
        scholarName:"al-Ḥusayn b. al-Ḥasan al-Karakī ",
        death:"(d. 1001/1592)"
     },
     "1":{
        sortingKey:"(d. 1009/1600)",
        scholarName:"al-Sayyid Muḥammad b. ʿAlī b. Abī al-Ḥasan al-Musawī al-ʿĀmilī, Ṣāḥib Madārik ",
        death:"(d. 1009/1600)"
     },
     "2":{
        scholarName:"Jamāl al-Dīn al-Ḥasan b. Zayn al-Dīn al-Shahīd al-Thānī al-ʿĀmilī, Ṣāḥib Maʿālim ",
        death:"(d. 1011/1602)",
        sortingKey:"(d. 1011/1602)"
     },
     "3":{
        sortingKey:"(d. 1016/1607)",
        scholarName:"Muḥammad b. Maḥmūd Dihdār al-Shirāzī ",
        death:"(d. 1016/1607)"
     },
     "4":{
        death:"(d. 1019/1610)",
        sortingKey:"(d. 1019/1610)",
        scholarName:"al-Sayyid Nūrullāh al-Ḥusaynī al-Shushtarī, al-Qāḍī Nūrullāh al-Shushtarī, al-Shahīd al-Thālith "
     },
     "5":{
        sortingKey:"(d. 1019/1610)",
        scholarName:"Shāh Taqī al-Dīn Muḥammad al-Nassāba al-Shirāzī ",
        death:"(d. 1019/1610)"
     },
     "6":{
        scholarName:"Mullā ‘Abd Allah b. al-Ḥusayn al-Tustarī ",
        death:"(d. 1021/1612)",
        sortingKey:"(d. 1021/1612)"
     },
     "7":{
        death:"(d. 1025/1616)",
        sortingKey:"(d. 1025/1616)",
        scholarName:"al-Mīrzā Muḥammad b. ʿAli al-Astarābādī, Ṣāḥib al-rijāl "
     },
     "8":{
        death:"(d. 1025/1616)",
        sortingKey:"(d. 1025/1616)",
        scholarName:"Fayḍullāh b. ʿAbd al-Qāhir al-Ḥusaynī al-Najafī a-Tafrishī, Mīr Fayḍullāh "
     },
     "9":{
        sortingKey:"(d. 1025/1616)",
        scholarName:"Ẓahīr al-Dīn/Rafīʿ al-Dīn al-Sayyid al-Mīrzā Ibrāhīm b. Qiwām al-Dīn al-Ḥusayn b. ʿAṭāʾullāh al-Ḥasan al-Ḥusaynī al-Hamadānī, Ibrāhīm Ḥamadānī, Qāḍīzadeh ",
        death:"(d. 1025/1616)"
     },
     "10":{
        sortingKey:"(d. 1028/1619)",
        scholarName:" Jamāl al-Dīn Mājid b. Hāshim b. ʿAlī al-Ḥusaynī, Abū ʿAlī al-Baḥrānī, al-Sayyid Majīd al-Baḥrānī ",
        death:"(d. 1028/1619)"
     },
     "11":{
        sortingKey:"(d. 1028/1619)",
        scholarName:"Muḥammad b. ʿAlī b. Ibrāhīm al-Astarābādī ",
        death:"(d. 1028/1619)"
     },
     "12":{
        death:"(d. 1030/1621)",
        sortingKey:"(d. 1030/1621)",
        scholarName:"Fakhr al-Dīn, Abū Jaʿfar Muḥammad b. al-Ḥasan b. Zayn al-Dīn al-ʿĀmilī, Ṣāḥib Maʿālim "
     },
     "13":{
        scholarName:"Bahāʾ al-Dīn Muḥammad b. ʿIzz al-Dīn al-Ḥusayn al-ʿĀmilī, al-Shaykh al-Bahāʾī ",
        death:"(d. 1030/1620 or 1031/1621)",
        sortingKey:"(d. 1030/1620 or 1031/1621)"
     },
     "14":{
        sortingKey:"(d. 1030/1620)",
        scholarName:"ʿAbd al-Nabī b. Saʿd al-Jazāʾirī, al-Shaykh ʿAbd al-Nabī al-Jazāʾirī ",
        death:"(d. c. 1030/1620)"
     },
     "16":{
        scholarName:"Muḥammad Amīn al-Astarābādī ",
        death:"(d. 1036/1626)",
        sortingKey:"(d. 1036/1626)"
     },
     "17":{
        death:"(d. 1041/1632)",
        sortingKey:"(d. 1041/1632)",
        scholarName:"Mīr Burhān al-Dīn Muḥammad Bāqir b. Muḥammad al-Ḥusaynī al-Astarābādī, Mīr Dāmād, al-Muʿallim al-Thālith "
     },
     "18":{
        sortingKey:"(d. 1041/1632 or 1081/1671)",
        scholarName:"Muḥammad Hādī b. Muḥammad Muʿīn al-Dīn al-Sharīf, Āṣif al-Shīrāzī ",
        death:"(d. 1041/1632 or 1081/1671)"
     },
     "20":{
        death:"(d. 1045/1635 or 1050/1640)",
        sortingKey:"(d. 1045/1635 or 1050/1640)",
        scholarName:"Ṣadr al-Dīn Muḥammad b. Ibrāhīm b. Yaḥyā al-Qawāmī al-Shīrāzī, Mullā Ṣadrā "
     },
     "21":{
        scholarName:"Abū al-Qāsim al-Findariskī, Mīr Findariskī ",
        death:"(d. 1050/1640)",
        sortingKey:"(d. 1050/1640)"
     },
     "22":{
        death:"(d. c. 1050/1640)",
        sortingKey:"(d. 1050/1640)",
        scholarName:"Muṣṭafā b. al-Ḥusayn al-Ḥusaynī al-Tafrishī "
     },
     "23":{
        sortingKey:"(d. 11th/17th century)",
        scholarName:"Zakī al-Dīn b. Sharaf al-Dīn ʿAlī b, Maḥmūd b. Sharaf al-Dīn al-Quhpāʾī al-Iṣfahānī al-Najafī, ʿInāyatullāh al-Quhpāʾī ",
        death:"(d. 11th/17th century)"
     },
     "24":{
        sortingKey:"(d. between 1054-1060/1645-1650)",
        scholarName:"al-Sayyid Aḥmad b. Zayn al-ʿĀbidīn al-ʿAlawī al-Ḥusaynī al-ʿĀmilī al-Iṣfahānī ",
        death:"(d. between 1054-1060/1645-1650)"
     },
     "25":{
        scholarName:"al-Qāḍī b. Kāshif al-Dīn Muḥammad al-Ardakānī al-Yazdī ",
        death:"(d. 1057/1647)",
        sortingKey:"(d. 1057/1647)"
     },
     "26":{
        sortingKey:"(d. 1059/1649)",
        scholarName:"Muḥammad b. ʿAlī b. Khātūn al-ʿĀmilī al-Ṭūsī, Ibn Khātūn al-ʿĀmilī ",
        death:"(d. 1059/1649)"
     },
     "27":{
        sortingKey:"(d. 1060/1650)",
        scholarName:"al-Sayyid Badr al-Dīn al-ʿAlawī, grandson of Mīr Dāmād ",
        death:"(d. after 1060/1650)"
     },
     "28":{
        sortingKey:"(d. 1061/1651 or 1068/1658)",
        scholarName:"al-Sayyid Nūr al-Dīn ʿAlī b. Abī al-Ḥasan al-Musawī al-ʿĀmilī ",
        death:"(d. 1061/1651 or 1068/1658)"
     },
     "29":{
        death:"(d. 1064/1653)",
        sortingKey:"(d. 1064/1653)",
        scholarName:"al-Sayyid Mīr ʿAlāʾ al-Dīn al-Ḥusayn b. Rafīʿ al-Dīn Muḥammad al-Ḥusaynī al-Āmulī al-Isfahānī, Sulṭān al-ʿUlamāʾ al-Ḥusayn al-Māzandarānī "
     },
     "30":{
        sortingKey:"(d. 1064/1653)",
        scholarName:"Mullā Muḥammad Ṣāliḥ Aḥmad al-Māzandarānī ",
        death:"(d. 1064/1653)"
     },
     "31":{
        scholarName:"ʿAlī b. Sulaymān b. al-Ḥasan al-Qadamī al-Baḥrānī, Umm al-ḥadīth ",
        death:"(d. 1064/1654)",
        sortingKey:"(d. 1064/1654)"
     },
     "32":{
        scholarName:"al-Shaykh Jawād b. Saʿdullāh b. Jawād al-Kāẓimī, al-Fāḍil al-Jawād ",
        death:"(d. 1065/1655)",
        sortingKey:"(d. 1065/1655)"
     },
     "33":{
        sortingKey:"(d. 1070/1659)",
        scholarName:"Muḥammad Taqī b. Maqṣūd ʿAlī al-Iṣfahānī, al-Majlisī al-Awwal ",
        death:"(d. 1070/1659)"
     },
     "34":{
        scholarName:"ʿAbdullāh b. Muḥammad al-Tūnī al-Bushrūyehī al-Khurāsānī, Fāḍil al-Tūnī ",
        death:"(d. 1071/1600)",
        sortingKey:"(d. 1071/1600)"
     },
     "35":{
        scholarName:"Mullā ʿAbd al-Razzāq ʿAlī b. al-Ḥusayn al-Lāhījī, Fayyāḍ ",
        death:"(d. 1051/1641 or 1072/1661)",
        sortingKey:"(d. 1051/1641 or 1072/1661)"
     },
     "36":{
        death:"(d. after 1072/1661)",
        sortingKey:"(d. 1072/1661)",
        scholarName:"Niẓām al-Dīn al-Gīlānī "
     },
     "37":{
        death:"(fl. 1073/1662)",
        sortingKey:"(d. 1073/1662)",
        scholarName:"ʿAbd ʿAlī b. Jumuʿa al-ʿArūsī al-Ḥuwayzī "
     },
     "38":{
        scholarName:"al-Ḥusayn b. Shihāb al-Dīn al-Biqāʿī al-Karakī al-ʿĀmīlī, Ibn Jāndār ",
        death:"(d. 1076/1666)",
        sortingKey:"(d. 1076/1666)"
     },
     "39":{
        death:"(d. 1078/1668)",
        sortingKey:"(d. 1078/1668)",
        scholarName:"al-Ḥusayn b. ʿAlī al-ʿĀmilī,  great great grandson of al-Shahīd al-Thānī, died at the young age of 21 "
     },
     "40":{
        sortingKey:"(d. 1080/1670)",
        scholarName:"Mullā Rajab ʿAli al-Tabrīzī ",
        death:"(d. 1080/1670)"
     },
     "41":{
        sortingKey:"(d. 1081/1670)",
        scholarName:"Mullā Muḥammad Ṣāliḥ b. Aḥmad b. Shams al-Dīn al-Sarawī al-Māzandarānī, Mullā Ṣāliḥ al-Māzandarānī ",
        death:"(d. 1081/1670)"
     },
     "42":{
        death:"(d. 1082/1671)",
        sortingKey:"(d. 1082/1671)",
        scholarName:"al-Sayyid Muḥammad Rafīʿ al-Dīn al-Ṭabāṭabāʾī, al-Mīrzā Rafīʿ al-Nāʾīnī "
     },
     "43":{
        scholarName:"al-Sayyid Muḥammad al-Musawī al-Ḥusaynī al-Sabzawārī al-Iṣfahānī, Mīr Lawḥī, al-Muṭahhar ",
        death:"(d. between 1083-1087/1672-1676)",
        sortingKey:"(d. 1083-1087/1672-1676)"
     },
     "44":{
        sortingKey:"(d. 1084/1673)",
        scholarName:"Muḥammad Muqīm al-Yazdī ",
        death:"(d. 1084/1673)"
     },
     "45":{
        death:"(d. 1085/1674 or 1087/1676)",
        sortingKey:"(d. 1085/1674 or 1087/1676)",
        scholarName:"Fakhr al-Dīn b. Muḥammad ʿAlī al-Ṭurayḥī "
     },
     "46":{
        sortingKey:"(d. 1085/1674)",
        scholarName:"Aḥmad b. ʿAbd al-Riḍā, Muhadhdhab al-Dīn al-Baṣrī al-Damāmīnī al-Ḥaydarābādī ",
        death:"(d. after 1085/1674)"
     },
     "47":{
        death:"(d. after 1087/1676)",
        sortingKey:"(d. 1087/1676)",
        scholarName:"ʿAbd al-Razzāq al-Rānkūʾī al-Gilānī "
     },
     "48":{
        sortingKey:"(d. 1089/1678)",
        scholarName:"Mullā Khalīl b. Ghāzī al-Qazwīnī ",
        death:"(d. 1089/1678)"
     },
     "49":{
        sortingKey:"(d. 1090/1679)",
        scholarName:"Muḥammad Bāqir b. Muḥammad Muʾmin al-Khurāsānī al-Sabzawārī, al-Muḥaqqiq al-Sabzawārī, Ṣāḥib al-Dhakhīra ",
        death:"(d. 1090/1679)"
     },
     "50":{
        sortingKey:"(d. 1090/1679)",
        scholarName:"Ḍāmin b. Shadqam al-Ḥusaynī al-Madanī ",
        death:"(d. 1090/1679)"
     },
     "51":{
        sortingKey:"(d. 1091/1680)",
        scholarName:"Shāh Qawām al-Dīn Ḥamza b. ʿAlī al-Nassāba al-Shīrāzī ",
        death:"(d. after 1091/1680)"
     },
     "52":{
        sortingKey:"(d. 1091/1680)",
        scholarName:"Mullā Muḥammad b. Murtaḍā b. Maḥmūd al-Kāshānī, Mullā Muḥsin al-Fayḍ al-Kāshānī ",
        death:"(d. 1091/1680)"
     },
     "53":{
        scholarName:"al-Sayyid Muḥammad Maʿṣūm al-Ḥusaynī al-Qazwīnī ",
        death:"(d. 1091/1680)",
        sortingKey:"(d. 1091/1680)"
     },
     "54":{
        scholarName:"Sharaf al-Dīn al-Mīrzā Muḥammad b. Muḥammad Riḍā al-Tabrīzī, Majdhūb al-Tabrīzī ",
        death:"(d. 1093/1682)",
        sortingKey:"(d. 1093/1682)"
     },
     "55":{
        sortingKey:"(d. 1093/1683)",
        scholarName:"Mīr Qawām al-Dīn al-Ṭihrānī al-Rāzī ",
        death:"(d. 1093/1683)"
     },
     "56":{
        sortingKey:"(d. 1095/1684)",
        scholarName:"Mullā Muḥammad Ṣāliḥ al-Khalkhālī ",
        death:"(d. 1095/1684)"
     },
     "57":{
        scholarName:"al-Ḥusayn b. Jamāl al-Dīn Muḥammad al-Khwānsārī, Āqā Ḥusayn al-Khwānsārī, al-Muḥaqqiq al-Khwānsārī ",
        death:"(d. 1098/1687)",
        sortingKey:"(d. 1098/1687)"
     },
     "58":{
        sortingKey:"(d. 1098/1687)",
        scholarName:"Mullā Muḥammad Ṭāhir al-Qummī ",
        death:"(d. 1098/1687)"
     },
     "59":{
        death:"(d. 1098/1687)",
        sortingKey:"(d. 1098/1687)",
        scholarName:"Muḥammad b. al-Ḥasan al-Shīrawānī, Muḥaqqiq Shīrawānī "
     },
     "101":{
        scholarName:"Ḥusayn b. Jamāl al-Dīn al-Khwānsārī, al-Muḥaqqiq al- al-Khwānsārī, Āghā Ḥusayn al-Khwānsārī ",
        death:"(d. 1099/1687)",
        sortingKey:"(d. 1099/1687)"
     },
     "102":{
        scholarName:"al-Mīrzā Rafīʿ al-Dīn Muḥammd b. Ḥaydar al-Ḥusaynī al-Ṭabāṭabāʾī al-Nāʾīnī",
        death:"(d. 1099/1688)",
        sortingKey:"(d. 1099/1688)"
     },
     "110":{
        sortingKey:"(d. 1040/1631)",
        scholarName:"Zayn al-ʿĀbīdīn b. Nūr al-Dīn ʿAlī al-Kāshānī",
        death:"(d. 1040/1631)"
     },
     "172":{
        sortingKey:"(d. 1001/1592)",
        scholarName:"al-Sayyid ʿAlī al-Ḥusaynī al-Astarābādī al-Najafī",
        death:"(d. 1001/1592)"
     }
  },
  "12":{
     "0":{
        death:"(d. 1101/1690 or 1105/1694)",
        sortingKey:"(d. 1101/1690 or 1105/1694)",
        scholarName:"al-Ḥusayn b. Ibrāhīm al-Tunikābunī "
     },
     "1":{
        sortingKey:"(d. 1101/1689)",
        scholarName:"Muḥammad b. ʿAlī al-Ardabilī ",
        death:"(d. 1101/1689)"
     },
     "2":{
        sortingKey:"(d. 1104/1693)",
        scholarName:"Muḥammad b. al-Ḥasan b. ʿAlī b. Muḥammad b. al-Ḥusayn al-Ḥurr al-ʿĀmilī, al-Shaykh al-Ḥurr al-ʿĀmilī ",
        death:"(d. 1104/1693)"
     },
     "3":{
        death:"(d. 1103/1692 or 1104/1693)",
        sortingKey:"(d. 1103/1692 or 1104/1693)",
        scholarName:"ʿAlī b. Muḥammad b. al-Ḥasan b. Zayn al-Dīn al-ʿĀmilī, al-Shaykh ʿAlī al-Kabīr "
     },
     "6":{
        sortingKey:"(d. 1103/1692)",
        scholarName:"ʿAlī b. Muḥammad al-ʿĀmilī,  great grandson of al-Shahīd al-Thānī",
        death:"(d. 1103/1692)"
     },
     "7":{
        sortingKey:"(d. 1103/1691 or 1107/1695 or later)",
        scholarName:"Qāḍī Saʿīd Muḥammad b. Muḥammad Mufīd al-Qummī, Qāḍī Saʿīd al-Qummī ",
        death:"(d. 1103/1691 or 1107/1695 or later)"
     },
     "8":{
        sortingKey:"(d. 1105/1693)",
        scholarName:"al-Sayyid ʿAbdul Ḥusayn al-Khātūnābādī ",
        death:"(d. 1105/1693)"
     },
     "9":{
        death:"(d. 1107/1695 or 1109/1697)",
        sortingKey:"(d. 1107/1695 or 1109/1697)",
        scholarName:"al-Sayyid Hāshim Baḥrānī "
     },
     "10":{
        death:"(d. 1111/1699)",
        sortingKey:"(d. 1111/1699)",
        scholarName:"Muḥammad Bāqir b. Muḥammad Taqī al-Majlisī, al-ʿAllāma al-Majlisī "
     },
     "11":{
        scholarName:"ʿAbdullāh b. Nūrullāh al-Baḥrānī al-Iṣfahānī ",
        death:"(d. 12th/18th century)",
        sortingKey:"(d. 12th/18th century)"
     },
     "12":{
        sortingKey:"(d. 12th/18th century)",
        scholarName:"Rafīʿ al-Dīn Muḥammad b. Muʾmin al-Gīlānī ",
        death:"(d. 12th/18th century)"
     },
     "13":{
        death:"(d. 12th/18th century)",
        sortingKey:"(d. 12th/18th century)",
        scholarName:"Muḥammad Shafīʿ b. Bahāʾ al-Dīn al-Ḥusaynī al-ʿĀmilī al-Karakī al-Qazwīnī, Fikrat "
     },
     "14":{
        scholarName:"al-Sayyid Niʿmat Allāh al-Jazāʾirī ",
        death:"(d. 1112/1701)",
        sortingKey:"(d. 1112/1701)"
     },
     "15":{
        death:"(d. 1115/1703)",
        sortingKey:"(d. 1115/1703)",
        scholarName:"Muḥammad b. Muḥsin Fayḍ al-Kāshānī, Muḥammad ʿAlam al-Hudā "
     },
     "16":{
        death:"(d. 1116/1705)",
        sortingKey:"(d. 1116/1705)",
        scholarName:"Muḥammad ʿAbd al-Bāqī "
     },
     "17":{
        scholarName:"al-Sayyid Ṣadr al-Dīn ʿAlī b. Aḥmad b. Muḥammad Maʿṣūm al-Ḥusaynī al-Dashtakī al-Shīrāzī, al-Sayyid ʿAlī Khān Madanī ",
        death:"(d. 1118/1706 or 1120/1708)",
        sortingKey:"(d. 1118/1706 or 1120/1708)"
     },
     "18":{
        death:"(d. 1121/1709)",
        sortingKey:"(d. 1121/1709)",
        scholarName:"al-Sayyid ʿAbd al-Ḥasīb b. Aḥmad b. Zayn al-ʿĀbidīn al-Ḥusaynī al-ʿAlawī al-ʿĀmilī al-Iṣfahānī, Mīr Dāmād’s daughter’s son and great grandson of al-Muḥaqqiq al-Karakī "
     },
     "19":{
        sortingKey:"(d. 1121/1709)",
        scholarName:"al-Shaykh Abū al-Ḥasan Sulaymān b. ʿAbdullāh b. ʿAlī al-Māḥūzī al-Baḥrānī, al-Muḥaqqiq al-Baḥrānī ",
        death:"(d. 1121/1709)"
     },
     "20":{
        scholarName:"Muḥammad b. ʿAbdul Fattāḥ al-Tunikābunī, al-Fāḍil al-Sarāb ",
        death:"(d. 1124/1712)",
        sortingKey:"(d. 1124/1712)"
     },
     "21":{
        death:"(d. 1125/1713)",
        sortingKey:"(d. 1125/1713)",
        scholarName:"Jamāl al-Dīn Muḥammad b. al-Ḥusayn b. Muḥammad al-Khwānsārī, Āghā Jamāl al-Khwānsārī "
     },
     "22":{
        sortingKey:"(d. 1126/1714)",
        scholarName:"Mīr Muḥammad Ṣālīḥ al-Khātūnābādī ",
        death:"(d. 1126/1714)"
     },
     "23":{
        death:"(d. 1127/1715)",
        sortingKey:"(d. 1127/1715)",
        scholarName:"Mīr Muḥammad Bāqir al-Khātūnābādī "
     },
     "24":{
        sortingKey:"(d. 1130/1717)",
        scholarName:"ʿAbdullāh b. ʿĪsā b. Muḥammad Ṣāliḥ al-Iṣfahānī al-Jīrānī, ʿAbdullāh al-Afandī ",
        death:"(d. 1130/1717)"
     },
     "25":{
        death:"(d. 1130/1717 or 1140/1727)",
        sortingKey:"(d. 1130/1717 or 1140/1727)",
        scholarName:"Muḥammad b. Muḥammad Bāqir al-Ḥusaynī al-Mukhtārī, al-Sayyid Bahāʾ al-Dīn "
     },
     "26":{
        death:"(d. 1130/1717)",
        sortingKey:"(d. 1130/1717)",
        scholarName:"Muḥammad b. Muḥammad al-Ḍarābī al-Shīrāzī, Mullā Shāh Muḥammad "
     },
     "27":{
        sortingKey:"(d. 1131/1718 or 1137/1724)",
        scholarName:"al-Mullā Muḥammad Zamān b. ʿAlī al-Iṣfahānī al-Tabrīzī",
        death:"(d. 1131/1718 or 1137/1724)"
     },
     "28":{
        death:"(d. 1131/1718)",
        sortingKey:"(d. 1131/1718)",
        scholarName:"Abū al-Faḍl Bahāʾ al-Dīn Muḥammad b. Tāj al-Dīn Ḥasan b. Muḥammad al-Iṣfahānī, al-Fāḍil al-Hindī, Kāshif al-lithām "
     },
     "29":{
        scholarName:"Āghā Muḥammad Mahdī b. Muḥammad Hādī b. Ṣāliḥ al-Māzandarānī ",
        death:"(d. 1134/1722)",
        sortingKey:"(d. 1134/1722)"
     },
     "30":{
        scholarName:"Ḥamza al-Gilānī ",
        death:"(d. c. 1134/1722)",
        sortingKey:"(d. 1134/1722)"
     },
     "31":{
        sortingKey:"(d. 1135/1722)",
        scholarName:"ʿAbdullāh b. Ṣāliḥ al-Samāhījī al-Baḥrānī ",
        death:"(d. 1135/1722)"
     },
     "32":{
        scholarName:"al-Sayyid Mīr Āṣif al-Qazwīnī, Āṣif-i Qazwīnī ",
        death:"(fl. 1135/1723)",
        sortingKey:"(d. 1135/1723)"
     },
     "33":{
        scholarName:"Mīr Sayyid Aḥmad al-ʿAlawī al-ʿĀmilī ",
        death:"(d. 1138/1725)",
        sortingKey:"(d. 1138/1725)"
     },
     "34":{
        sortingKey:"(d. 1145/1732)",
        scholarName:"Ibrāhīm b. Maʿṣūm b. Faṣīḥ al-Ḥusaynī al-Qazwīnī, Ibrāhīm al-Qazwīnī ",
        death:"(d. 1145/1732)"
     },
     "35":{
        death:"(d. c. 1150/1737)",
        sortingKey:"(d. 1150/1737)",
        scholarName:"Muḥammad Jaʿfar b. Muḥammad Ṭāhir al-Karbāsī al-Khurāsānī al-Iṣfahānī "
     },
     "36":{
        sortingKey:"(d. 1151/1738)",
        scholarName:"Mīr Muḥammad Ḥusayn al-Khātūbābādī ",
        death:"(d. 1151/1738)"
     },
     "37":{
        scholarName:"Abū al-Qāsim Jaʿfar b. al-Ḥusayn al-Khwānsārī, Mīr Kabīr ",
        death:"(d. 1157/1744 or 1158/1745)",
        sortingKey:"(d. 1157/1744 or 1158/1745)"
     },
     "38":{
        death:"(d. 1158/1745)",
        sortingKey:"(d. 1158/1745)",
        scholarName:"al-Sayyid Nūr al-Dīn al-Jazāʾirī "
     },
     "39":{
        death:"(d. 1159/1746)",
        sortingKey:"(d. 1159/1746)",
        scholarName:"Muḥammad Zakī b. Ibrāhīm, al-Khaṭīb al-Kirmānshāhī "
     },
     "40":{
        death:"(d. 1172/1759)",
        sortingKey:"(d. 1172/1759)",
        scholarName:"Muḥammad Zamān al-Kāshānī "
     },
     "41":{
        sortingKey:"(d. 1173/1759)",
        scholarName:"Ismāʿīl b. Muḥammad al-Ḥusayn al-Māzandarānī, al-Khājūʾī ",
        death:"(d. 1173/1759)"
     },
     "42":{
        death:"(d. 1173/1759)",
        sortingKey:"(d. 1173/1759)",
        scholarName:"al-Sayyid ʿAbdullāḥ b. Nūr al-Dīn al-Jazāʾirī"
     },
     "43":{
        sortingKey:"(d. 1180/1766)",
        scholarName:"Muḥammad ʿAlī b. Abī Ṭālib, Ḥazīn al-Lāhījī ",
        death:"(d. 1180/1766)"
     },
     "44":{
        sortingKey:"(d. 1186/1772)",
        scholarName:"Yusūf b. Aḥmad al-Baḥrānī, al-Muḥaddith al-Baḥrānī, Ṣāḥib Ḥadāʾiq ",
        death:"(d. 1186/1772)"
     },
     "45":{
        scholarName:"Shubbar b. Muḥammad al-Ḥuwayzī ",
        death:"(d. 1186/1772 or 1190/1776)",
        sortingKey:"(d. 1186/1772 or 1190/1776)"
     },
     "46":{
        sortingKey:"(d. 1191/1777)",
        scholarName:"al-Sayyid Ḥusayn al-Khwānsārī",
        death:"(d. 1191/1777)"
     },
     "47":{
        sortingKey:"(d. 1197/1783)",
        scholarName:"al-Shaykh ʿAbd al-Nabī al-Qazwīnī al-Yazdī ",
        death:"(d. c. 1197/1783)"
     },
     "48":{
        sortingKey:"(d. 1192/1779)",
        scholarName:"Beginning of the Qajar rule in Iran (1192-1343/1779-1925)",
        death:"(1192/1779)",
        color:"#eeddbb"
     },
     "101":{
        death:"(d. 1160/1747)",
        sortingKey:"(d. 1160/1747)",
        scholarName:"Muḥammad Ibrāhīm b. Ghiyāth al-Dīn Muḥammad b. Muḥammad Rafīʿ b. Muḥammad Shafīʿ al-Iṣfahānī al-Khūzānī, al-Ḥuwayzāwī"
     },
     "232":{
        sortingKey:"(d. 1135/1722)",
        scholarName:"End of the Safavid rule (907-1135/1502-1722) ",
        death:"(1135/1722)",
        color:"#eeddbb"
     }
  },
  "13":{
     "0":{
        sortingKey:"(d. 1205/1791)",
        scholarName:"Muḥammad Bāqir b. Muḥammad Akmal, al-Waḥīd al-Bihbihānī ",
        death:"(d. c. 1205/1791)"
     },
     "1":{
        sortingKey:"(d. 1208/1794)",
        scholarName:"Muḥammad Riḍā b. ʿAbd al-Muṭṭalib al-Tabrīzī ",
        death:"(d. 1208/1794)"
     },
     "2":{
        sortingKey:"(d. 1209/1795)",
        scholarName:"Muḥammad Mahdī b. Abī Dharr al-Fāḍil al-Narāqī, al-Muḥaqqiq al-Narāqī ",
        death:"(d. 1209/1795)"
     },
     "3":{
        scholarName:"al-Sayyid Muḥammad Mahdī b. Murtaḍa b. Muḥammad al-Ṭabāṭabāʾī, al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm",
        death:"(d. 1212/1797)",
        sortingKey:"(d. 1212/1797)"
     },
     "4":{
        death:"(d. 1215/1800 or 1216/1801)",
        sortingKey:"(d. 1215/1800 or 1216/1801)",
        scholarName:"Muḥammad b. Ismāʿīl b. ʿAbd al-Jabbār, Abū ʿAlī al-Ḥāʾirī "
     },
     "5":{
        sortingKey:"(d. 1216/1801)",
        scholarName:"al-Mīrzā Mahdī al-Shahristānī ",
        death:"(d. 1216/1801)"
     },
     "6":{
        sortingKey:"(d. 1216/1801)",
        scholarName:"Muḥammad ʿAlī b. Waḥīd al-Bihbihānī, Āqā Muḥammad ʿAlī al-Kirmānshāhī ",
        death:"(d. 1216/1801)"
     },
     "7":{
        death:"(d. 1216/1801)",
        sortingKey:"(d. 1216/1801)",
        scholarName:"al-Shaykh al-Ḥusayn al-Baḥrānī Āl ʿUsfūr "
     },
     "8":{
        sortingKey:"(d. 1216/1802)",
        scholarName:"Mullā ʿAbd al-Ṣamad al-Hamadānī ",
        death:"(d. 1216/1802)"
     },
     "9":{
        death:"(d. 1218/1803)",
        sortingKey:"(d. 1218/1803)",
        scholarName:"Mīrzā Muḥammad Mahdī al-Khurāsānī, al-Shahīd al-Thālith, al-Shahīd al-Rābiʿ "
     },
     "10":{
        sortingKey:"(d. 1218/1803)",
        scholarName:"al-Mīrza Muḥammad Ḥasan b. ʿAbd al-Rasūl b. al-Ḥasan b. Muḥammad Riḍā al-Ḥusaynī al-Zunūzī, al-Fānī ",
        death:"(d. 1218/1803)"
     },
     "11":{
        scholarName:"al-Sayyid Muḥammad Jawād b. Muḥammad al-Ḥusaynī al-ʿĀmilī al-Shaqrāʾī al-Najafī, Ṣāḥib Miftāḥ al-karāma",
        death:"(d. 1226/1811 or 1228/1813)",
        sortingKey:"(d. 1226/1811 or 1228/1813)"
     },
     "12":{
        death:"(d. 1227/1812)",
        sortingKey:"(d. 1227/1812)",
        scholarName:"al-Sayyid Muḥsin b. Ḥasan b. Murtaḍā b. Sharīf al-Dīn al-Ḥusaynī al-Aʿrajī al-Kaẓimī, al-Muḥaqqiq al-Aʿrajī "
     },
     "13":{
        sortingKey:"(d. 1228/1813)",
        scholarName:"al-Shaykh Jaʿfar b. Khiḍr b. Yaḥyā al-Jinājī al-Ḥillī al-Najafī, Kāshif al-Ghiṭāʾ ",
        death:"(d. 1228/1813)"
     },
     "14":{
        death:"(d. 1231/1816)",
        sortingKey:"(d. 1231/1816)",
        scholarName:"al-Mīrzā Abū al-Qāsim b. Muḥammad al-Ḥasan al-Shaftī al-Qummī, al-Mīrzā al-Qummī, al-Muḥaqqiq al-Qummī "
     },
     "15":{
        sortingKey:"(d. 1231/1816)",
        scholarName:"al-Sayyid ʿAlī b. Muḥammad ʿAlī b. Abū al-Maʿālī al-Ṣaghīr b. Abū al-Maʿālī al-Kabīr al-Ṭabāṭabāʾī, Ṣāḥib Riyāḍ",
        death:"(d. 1231/1816)"
     },
     "16":{
        sortingKey:"(d. 1231/1816)",
        scholarName:"al-Sayyid ʿAbd al-Aẓīm b. ʿAlī Rīḍā al-Ḥusaynī al-Linjānī al-Iṣfahānī ",
        death:"(d. after 1231/1816)"
     },
     "17":{
        sortingKey:"(d. 1232/1817 or 1233/1818)",
        scholarName:"Abū Aḥmad Jamāl al-Dīn b. ʿAbd al-Nabī b. ʿAbd al-Ṣāniʿ al-Nayshāpūrī al-Astarābādī, al-Mīrzā Muḥammad al-Akhbārī ",
        death:"(d. 1232/1817 or 1233/1818)"
     },
     "18":{
        sortingKey:"(d. 1233/1817)",
        scholarName:"al-Mīr Muḥammad Ḥusayn b. ʿAbd al-Bāqī al-Iṣfahānī al-Khātūnābādī ",
        death:"(d. 1233/1817)"
     },
     "19":{
        death:"(d. 1234/1819)",
        sortingKey:"(d. 1234/1819)",
        scholarName:"Asadullāh al-Shūshtarī "
     },
     "20":{
        death:"(d. 1235/1820)",
        sortingKey:"(d. 1235/1820)",
        scholarName:"al-Sayyid Dildār ʿAlī b. Muḥammad al-Naqawī al-Lakhnawī, Ghufrān Maʾāb "
     },
     "21":{
        scholarName:"al-Sayyid Aḥmad b. Muḥammad ʿAlī al-Bihbihānī, Āqā Aḥmad al-Kirmānshāhī ",
        death:"(d. 1235/1820)",
        sortingKey:"(d. 1235/1820)"
     },
     "22":{
        scholarName:"al-Shaykh Asadullāh al-Kāẓimī ",
        death:"(d. 1237/1821)",
        sortingKey:"(d. 1237/1821)"
     },
     "23":{
        death:"(d. 1240/1824)",
        sortingKey:"(d. 1240/1824)",
        scholarName:"Abū al-Qāsim Jaʿfar b. al-Ḥusayn al-Khwānsārī, Āqā Mīrzā, Mīr Ṣaghīr "
     },
     "24":{
        scholarName:"Muḥammad Ḥasan al-Qazwīnī ",
        death:"(d. 1240/1824)",
        sortingKey:"(d. 1240/1824)"
     },
     "25":{
        sortingKey:"(d. 1240/1825)",
        scholarName:"Mullā Ismāʿīl b. Muḥammad Samīʿ Darb Kūshakī al-Iṣfahānī ",
        death:"(d. c. 1240/1825)"
     },
     "26":{
        sortingKey:"(d. 1240/1825)",
        scholarName:"al-Sayyid Muḥammad Bāqir b. Muḥammad Mullā Bāshī al-Musawī al-Shīrāzī ",
        death:"(d. 1240/1825)"
     },
     "27":{
        sortingKey:"(d. 1242/1826)",
        scholarName:"al-Sayyid Muḥammad b. ʿAlī Ṭabāṭabāʾī, al-Sayyid Muḥammad Mujāhid, Ṣāḥib Manāhil ",
        death:"(d. 1242/1826)"
     },
     "28":{
        sortingKey:"(d. 1241/1825)",
        scholarName:"al-Shaykh Aḥmad al-Iḥsāʾī ",
        death:"(d. 1241/1825)"
     },
     "29":{
        scholarName:"al-Sayyid ʿAbdullāh b. al-Sayyid Muḥammad Riḍā Shubbar al-Ḥusaynī al-Najafī al-Kāẓimī, al-Sayyid ʿAbdullāh Shubbar ",
        death:"(d. 1242/1826)",
        sortingKey:"(d. 1242/1826)"
     },
     "30":{
        sortingKey:"(d. 1242/1826 or 1243/1827)",
        scholarName:"al-Shaykh Mūsā b. Jaʿfar Kāshif al-Ghiṭāʾ ",
        death:"(d. 1242/1826 or 1243/1827)"
     },
     "31":{
        sortingKey:"(d. 1245/1829)",
        scholarName:"Aḥmad b. Muḥammad Mahdī b. Abū Dharr al-Narāqī al-Kāshānī, Mullā Aḥmad al-Narāqī, Fāḍil al-Narāqī ",
        death:"(d. 1245/1829)"
     },
     "32":{
        death:"(d. 1245/1829 or 1246/1830)",
        sortingKey:"(d. 1245/1829 or 1246/1830)",
        scholarName:"al-Shaykh Muḥammad Sharīf b. Ḥasan ʿAlī al-Āmulī al-Māzandarānī al-Ḥāʾirī, Sharīf al-ʿulamāʾ al-Māzandarānī"
     },
     "33":{
        death:"(d. 1246/1830)",
        sortingKey:"(d. 1246/1830)",
        scholarName:"Muḥammad Sharīf b. al-Ḥasan ʿAlī al-Āmulī al-Māzandarānī al-Ḥāʾirī "
     },
     "34":{
        sortingKey:"(d. 1246/1830)",
        scholarName:"Mullā ʿAlī b. Jamshayd al-Nūrī al-Māzandarānī al-Iṣfahānī, Mullā ʿAlī al-Nūrī ",
        death:"(d. 1246/1830)"
     },
     "35":{
        death:"(d. 1248/1832)",
        sortingKey:"(d. 1248/1832)",
        scholarName:"Muḥammad Taqī Rāzī al-Īwānakī al-Iṣfahānī, Ṣāḥib Hidāyat al-mustarshidīn "
     },
     "36":{
        sortingKey:"(d. 1249/1833)",
        scholarName:"al-Mīrzā ʿAbd al-Wahhāb b. Muḥammad Ṣāliḥ al-Baraghānī al-Qazwīnī ",
        death:"(d. 1249/1833)"
     },
     "37":{
        sortingKey:"(d. 1250/1834)",
        scholarName:"Muḥammad Ḥusayn al-Ḥāʾirī ",
        death:"(d. 1250/1834)"
     },
     "38":{
        sortingKey:"(d. 1250/1834)",
        scholarName:"Mīr ʿAbdul Fattāḥ b. ʿAlī al-Ḥusaynī al-Marāghī ",
        death:"(d. 1250/1834)"
     },
     "39":{
        death:"(d. 1253/1837)",
        sortingKey:"(d. 1253/1837)",
        scholarName:"Sahaykh ʿAlī b. Jaʿfar Āl Kāshif al-Ghiṭāʾ"
     },
     "40":{
        scholarName:"ʿAlī b. Jaʿfar Kāshif al-Ghiṭāʾ al-Mālikī al-Najafī ",
        death:"(d. 1253/1837)",
        sortingKey:"(d. 1253/1837)"
     },
     "41":{
        scholarName:"Mullā ʿAbdullāh al-Zanūzī ",
        death:"(d. 1257/1841)",
        sortingKey:"(d. 1257/1841)"
     },
     "42":{
        sortingKey:"(d. 1259/1843)",
        scholarName:"al-Sayyid Kāẓim al-Rashtī ",
        death:"(d. 1259/1843)"
     },
     "43":{
        sortingKey:"(d. 1260/1844)",
        scholarName:"al-Sayyid Muḥammad Bāqir Ḥujjat al-Islām al-Shaftī al-Iṣfahānī ",
        death:"(d. 1260/1844)"
     },
     "44":{
        death:"(d. 1260/1844)",
        sortingKey:"(d. 1260/1844)",
        scholarName:"Muḥammad Jaʿfar al-Lāhījī al-Langarūdī "
     },
     "45":{
        sortingKey:"(d. 1261/1845)",
        scholarName:"Muḥammad Ibrāhīm al-Kalbāsī ",
        death:"(d. 1261/1845)"
     },
     "46":{
        sortingKey:"(d. 1254/1838 or 1255/1839 or 1261/1845)",
        scholarName:"Muḥammad Ḥusayn b. ʿAbd al-Raḥīm al-Ḥāʾirī al-Iṣfahānī, Ṣāḥib al-Fuṣūl ",
        death:"(d. 1254/1838 or 1255/1839 or 1261/1845)"
     },
     "47":{
        sortingKey:"(d. 1262/1846)",
        scholarName:"Ibrāhīm b. Muḥammad Bāqir al-Qazwīnī ",
        death:"(d. 1262/1846)"
     },
     "48":{
        scholarName:"Muḥammad Jaʿfar Sharīʿatmadār al-Astarābādī ",
        death:"(d. 1263/1846)",
        sortingKey:"(d. 1263/1846)"
     },
     "49":{
        death:"(d. 1263/1846)",
        sortingKey:"(d. 1263/1846)",
        scholarName:"Mīr Muḥammad Mahdī b. Murtaḍā al-Khātūnābādī, Āqābuzurg "
     },
     "50":{
        sortingKey:"(d. 1263/1847)",
        scholarName:"Muḥammad Taqī al-Baraghānī ",
        death:"(d. 1263/1847)"
     },
     "51":{
        sortingKey:"(d. 1264/1847)",
        scholarName:"al-Sayyid Ibrāhīm b. Muḥammad Bāqir al-Musawī al-Qazwīnī al-Ḥāʿirī, Ṣāḥib Ḍawābiṭ",
        death:"(d. 1264/1847)"
     },
     "52":{
        sortingKey:"(d. 1264/1847)",
        scholarName:"al-Sayyid Ibrāhīm b. Muḥammad Bāqir al-Musawī al-Qazwīnī ",
        death:"(d. 1264/1847)"
     },
     "53":{
        death:"(d. 1264/1847)",
        sortingKey:"(d. 1264/1847)",
        scholarName:"Mahdī b. al-Ḥasan b. al-Ḥausayn al-Musawī al-Khwānsārī "
     },
     "54":{
        scholarName:"al-Sayyid Ṣadr al-Dīn al-Musawī al-ʿĀmilī al-Iṣfahānī ",
        death:"(d. 1264/1847)",
        sortingKey:"(d. 1264/1847)"
     },
     "55":{
        death:"(d. 1264/1847)",
        sortingKey:"(d. 1264/1847)",
        scholarName:"Muḥammad Taqī b. Muḥammad al-Baraghānī "
     },
     "56":{
        scholarName:"Aḥmad Mujtahid b. Lutf ʿAlī b. Muḥammad Ṣādiq ",
        death:"(d. 1265/1849)",
        sortingKey:"(d. 1265/1849)"
     },
     "57":{
        sortingKey:"(d. 1266/1850)",
        scholarName:"Muḥammad Ḥasan b. Bāqir b. ʿAbd al-Raḥim al-Iṣfahānī al-Najafī, Ṣāḥib Jawāhir ",
        death:"(d. 1266/1850)"
     },
     "58":{
        sortingKey:"(d. 1266/1850)",
        scholarName:"Mullā Aḥmad al-Khūʾīnī, Ḥāj Āqā Mullā ",
        death:"(d. 1266/1850)"
     },
     "59":{
        sortingKey:"(d. 1267/1851)",
        scholarName:"al-Sayyid Jaʿfar b. Abū Isḥāq al-Dārābī, al-Kashfī ",
        death:"(d. 1267/1851)"
     },
     "60":{
        scholarName:"al-Sayyid Muḥammad Qūlī al-Musawī al-Hindi al-Nishāpūrī, al-ʿAllāmā al-Kuntūrī ",
        death:"(d. 1268/1851)",
        sortingKey:"(d. 1268/1851)"
     },
     "61":{
        scholarName:"Mīrzā Abū al-Qāsim al-Khātūnābādī, Āqā ",
        death:"(d. 1270/1853 or 1271/1854)",
        sortingKey:"(d. 1270/1853 or 1271/1854)"
     },
     "62":{
        scholarName:"Mullā Muḥammad Saʿīd al-Bārfurushī al-Māzandarānī, Saʿīd al-ʿUlamāʾ al-Māzandarānī ",
        death:"(d. 1270/1853)",
        sortingKey:"(d. 1270/1853)"
     },
     "63":{
        scholarName:"Muḥammad Ṣāliḥ al-Baraghānī al-Qazwīnī ",
        death:"(d. 1271/1855)",
        sortingKey:"(d. 1271/1855)"
     },
     "64":{
        sortingKey:"(d. 1273/1856)",
        scholarName:"al-Sayyid Ḥusayn ʿAlliyyīn b. al-Sayyid Dildār ʿAlī al-Naqawī ",
        death:"(d. 1273/1856)"
     },
     "65":{
        death:"(d. 1275/1858)",
        sortingKey:"(d. 1275/1858)",
        scholarName:"Zayn al-ʿĀbidīn b. Jaʿfar b. al-Ḥusayn al-Khwānsārī "
     },
     "66":{
        death:"(d. 1274/1858)",
        sortingKey:"(d. 1274/1858)",
        scholarName:"Muḥammad ʿAlī b. Muḥammad b. Ṣāliḥ b. Muḥammad b. Ibrāhīm al-Musawī al-ʿĀmilī al-Iṣfahānī, Āqā Mujtahid "
     },
     "67":{
        sortingKey:"(d. 1280/1863)",
        scholarName:"al-Sayyid Muḥammad al-Shafīʿ al-Jāpalaqī ",
        death:"(d. 1280/1863)"
     },
     "68":{
        scholarName:"Muḥammad Ṣāliḥ al-Māzandarānī ",
        death:"(d. 1280/1864)",
        sortingKey:"(d. 1280/1864)"
     },
     "69":{
        scholarName:"al-Shaykh Murtaḍā al-Dezfūlī al-Anṣārī ",
        death:"(d. 1281/1864)",
        sortingKey:"(d. 1281/1864)"
     },
     "70":{
        scholarName:"Ibrāhīm b. al-Ṣādiq al-ʿĀmilī ",
        death:"(d. 1284/1867)",
        sortingKey:"(d. 1284/1867)"
     },
     "71":{
        sortingKey:"(d. 1285/1868)",
        scholarName:"Mullā Ṣāliḥ b. Mullā Muḥammad Ḥasan b. Mullā ʿAbd al-Fattāḥ b. Mullā Muḥammad Riḍā b. Muḥammad b. ʿAbdul Fattāḥ al-Tunikābunī, Ṣāliḥ al-Muʾminīn ",
        death:"(d. 1285/1868)"
     },
     "72":{
        sortingKey:"(d. 1285/1868)",
        scholarName:"Muḥammad Bāqir b. ʿAbd al-Karīm al-Bihbihānī ",
        death:"(d. 1285/1868)"
     },
     "73":{
        sortingKey:"(d. 1286/1869)",
        scholarName:"ʿAbd al-Ḥusayn al-Tihrānī, Shaykh al-ʿIrāqiyīn ",
        death:"(d. 1286/1869)"
     },
     "74":{
        sortingKey:"(d. 1286/1869)",
        scholarName:"Ākhūnd Mullā Āqā b. ʿĀbid b. Ramaḍān ʿAlī b. Zāhid al-Shīrawānī, al-Fāḍil al-Darbandī ",
        death:"(d. 1286/1869)"
     },
     "75":{
        sortingKey:"(d. 1286/1869)",
        scholarName:"al-Sayyid Muḥammad b. al-Sayyid Dildār ʿAlī al-Naqawī, Sulṭān al-ʿulamāʾ, Riḍwān Maʾāb ",
        death:"(d. 1286/1869)"
     },
     "76":{
        sortingKey:"(d. 1288/1873)",
        scholarName:"Muḥammad Karīm Khān al-Kirmānī ",
        death:"(d. 1288/1873)"
     },
     "77":{
        death:"(d. 1289/1873)",
        sortingKey:"(d. 1289/1873)",
        scholarName:"Mullā Hādī al-Sabzawārī "
     },
     "78":{
        scholarName:"al-Mawlā ʿAlī al-Rūzdarī ",
        death:"(d. c. 1290/1874)",
        sortingKey:"(d. 1290/1874)"
     },
     "79":{
        sortingKey:"(d. 1292/1876)",
        scholarName:"Mīrzā Abū al-Qāsim al-Tihrānī, Kalāntar Tihrānī ",
        death:"(d. 1292/1876)"
     },
     "80":{
        death:"(d. 1294/1877)",
        sortingKey:"(d. 1294/1877)",
        scholarName:"Mīrzā ʿAbd al-Waḥḥāb al-Ṣāliḥī "
     },
     "81":{
        death:"(d. 1297/1880)",
        sortingKey:"(d. 1297/1880)",
        scholarName:"Mullā ʿAlī al-Tihrānī "
     },
     "82":{
        scholarName:"Mīrzā Muḥammad Taqī Sipehr, Lisān al-mulk ",
        death:"(d. 1297/1880)",
        sortingKey:"(d. 1297/1880)"
     },
     "83":{
        sortingKey:"(d. 1298/1881)",
        scholarName:"al-Sayyid ʿAlī al-Musawī al-Qazwīnī ",
        death:"(d. 1298/1881)"
     },
     "84":{
        sortingKey:"(d. 1299/1882)",
        scholarName:"al-Sayyid Ḥusayn b. Muḥammad b. Ḥasan al-Ḥusaynī al-Khukamarī al-Najafī",
        death:"(d. 1299/1882)"
     },
     "85":{
        death:"(d. after 1300/1882)",
        sortingKey:"(d. 1300/1882)",
        scholarName:"Ḥusayn al-Turbatī "
     },
     "101":{
        death:"(d. 1234/1819 or 1237/1821)",
        sortingKey:"(d. 1234/1819 or 1237/1821)",
        scholarName:"Asadullāh b. Ismāʿīl al-Tustarī al-Kāẓimī"
     },
     "105":{
        sortingKey:"(d. 1274/1858)",
        scholarName:"End of the Mughal Empire (932-1274/1526-1858)",
        death:"(1274/1858)",
        color:"#eeddbb"
     },
     "112":{
        scholarName:"al-Shaykh Ḥusayn b. al-Ḥājj Najaf ʿAlī b. Muḥammad al-Tabrīzī",
        death:"(d. 1251/1835)",
        sortingKey:"(d. 1251/1835)"
     },
     "122":{
        scholarName:"al-Shaykh Khiḍr b. Shallāl al-ʿAfkāwī al-Bāhilī al-Najafī",
        death:"(d. c. 1255/1839)",
        sortingKey:"(d. 1255/1839)"
     },
     "133":{
        death:"(d. 1216/1801)",
        sortingKey:"(d. 1216/1801)",
        scholarName:"al-Sayyid Mahdī b. al-Mīrzā Abū al-Qāsim al-Musawī al-Iṣfahānī al-Shahristānī al-Ḥāʾirī"
     },
     "134":{
        scholarName:"al-Sayyid Riḍā b. al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm",
        death:"(d. 1253/1838)",
        sortingKey:"(d. 1253/1838)"
     },
     "135":{
        sortingKey:"(d. 1298/1880)",
        scholarName:"al-Sayyid ʿAlī b. al-Sayyid Riḍā b. al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm",
        death:"(d. 1298/1880)"
     },
     "144":{
        scholarName:"al-Shaykh Muḥammad Riḍā b. al-Shaykh Mūsā b. Kāshif al-Ghiṭāʾ",
        death:"(d. 1297/1879)",
        sortingKey:"(d. 1297/1879)"
     },
     "145":{
        sortingKey:"(d. 1247/1830)",
        scholarName:"al-Shaykh Khalaf b. Ḥājj ʿAskar al-Ḥāʾirī",
        death:"(d. 1247/1830)"
     },
     "154":{
        sortingKey:"(d. 1289/1872)",
        scholarName:"al-Shaykh Mahdī b. al-Shaykh ʿAlī Kāshif al-Ghiṭāʾ",
        death:"(d. 1289/1872)"
     },
     "156":{
        scholarName:"al-Sayyid Muḥammad Taqī b. al-Sayyid Riḍā b. al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm",
        death:"(d. 1289/1872)",
        sortingKey:"(d. 1289/1872)"
     },
     "177":{
        sortingKey:"(d. 1290/1873)",
        scholarName:"al-Shaykh Raḍī b. Muḥammad b. Ḥusayn b. Khiḍr b. Yaḥyā al-Najafī",
        death:"(d. 1290/1873)"
     },
     "187":{
        scholarName:"al-Shaykh Muḥammad b. al-Shaykh ʿAlī b. Jaʿfar Kāshif al-Ghiṭāʾ",
        death:"(d. 1268/1851)",
        sortingKey:"(d. 1268/1851)"
     },
     "188":{
        sortingKey:"(d. 1290/1873)",
        scholarName:"al-Shaykh Jaʿfar b. al-Shaykh ʿAlī b. al-Shaykh Jaʿfar Kāshif al-Ghiṭāʾ",
        death:"(d. 1290/1873)"
     },
     "199":{
        sortingKey:"(d. 1292/1875)",
        scholarName:"al-Sayyid Zayn al-ʿĀbidīn b. Ḥusayn b. Muḥammad al-Mujāhid al-Ṭabāṭabāʾī",
        death:"(d. 1292/1875)"
     },
     "201":{
        sortingKey:"(d. 1249/1833)",
        scholarName:"al-Sayyid Muḥammad Mahdī b. ʿAlī al-Ṭabāṭabāʾī al-Ḥāʾirī",
        death:"(d. 1249/1833)"
     },
     "202":{
        sortingKey:"(d. 1289/1873)",
        scholarName:"al-Sayyid ʿAlī Naqī b. Ḥusayn b. Muḥammad al-Mujāhid al-Ṭabāṭabāʾī",
        death:"(d. 1289/1873)"
     },
     "233":{
        sortingKey:"(d. 1254/1839)",
        scholarName:"al-Shaykh Muḥammad Ḥusayn al-Iṣfahānī b. Muḥammad ʿAbd al-Raḥīm al-Aywānkāfī al-Warāminī al-Tihrānī al-Iṣfahānī",
        death:"(d. 1254/1839)"
     },
     "234":{
        scholarName:"al-Shaykh Ḥasan b. al-Shaykh Jaʿfar Kāshif al-Ghiṭāʾ",
        death:"(d. 1262/1845)",
        sortingKey:"(d. 1262/1845)"
     },
     "290":{
        sortingKey:"(d. 1270/1853)",
        scholarName:"al-Shaykh Muḥsin b. Muḥammad b. Khanfar",
        death:"(d. 1270/1853)"
     },
     "301":{
        death:"(d. 1298/1881)",
        sortingKey:"(d. 1298/1881)",
        scholarName:"Mullā ʿAlī b. al-Mīrzā Khalīl al-Rāzī al-Tihrānī"
     }
  },
  "14":{
     "0":{
        sortingKey:"(d. 1301/1883)",
        scholarName:"Muḥammad Bāqir Āqā al-Najafī al-Iṣfahānī al-Masjidshāhī ",
        death:"(d. 1301/1883)"
     },
     "1":{
        sortingKey:"(d. 1302/1884)",
        scholarName:"Muḥammad b. Sulaymān al-Tunikābunī ",
        death:"(d. 1302/1884)"
     },
     "2":{
        scholarName:"al-Shaykh Jaʿfar al-Shūshtarī ",
        death:"(d. 1303/1885)",
        sortingKey:"(d. 1303/1885)"
     },
     "3":{
        sortingKey:"(d. 1306/1888)",
        scholarName:"al-Sayyid Mahdī Abū Ẓafar, Mīr Ḥāmid Ḥusayn al-Hindī, Ṣāḥib ʿAbaqāt ",
        death:"(d. 1306/1888)"
     },
     "4":{
        sortingKey:"(d. 1306/1888)",
        scholarName:"Mullā ʿAlī al-Kanī ",
        death:"(d. 1306/1888)"
     },
     "5":{
        death:"(d. 1306/1888)",
        sortingKey:"(d. 1306/1888)",
        scholarName:"Mīrzā Abū al-Qāsim b. Zayn al-ʿĀbidīn "
     },
     "6":{
        scholarName:"al-Sayyid Mahdī Abū Ẓafar, Mīr Ḥāmid Ḥusayn al-Hindī al-Naqavī, Ṣāḥib ʿAbaqāt ",
        death:"(d. 1306/1888)",
        sortingKey:"(d. 1306/1888)"
     },
     "7":{
        scholarName:"al-Muftī al-Sayyid Muḥammad ʿAbbās al-Shūshtarī al-Musawī al-Kantūrī al-Hindī ",
        death:"(d. 1306/1889)",
        sortingKey:"(d. 1306/1889)"
     },
     "8":{
        death:"(d. 1306/1889)",
        sortingKey:"(d. 1306/1889)",
        scholarName:"Muḥammad Riḍā al-Qumshiʾī "
     },
     "9":{
        sortingKey:"(d. 1307/1890)",
        scholarName:"Ibrāhīm b. Muḥammad Taqī b. al-Ḥusayn b. Dildār ʿAli al-Naqawī al-Naṣīrābādī, Ibrāhīm al-Lakhnawī ",
        death:"(d. 1307/1890)"
     },
     "10":{
        sortingKey:"(d. 1307/1890)",
        scholarName:"Mullā Aḥmad al- Khūʾinī ",
        death:"(d. 1307/1890)"
     },
     "11":{
        death:"(d. 1307/1890)",
        sortingKey:"(d. 1307/1890)",
        scholarName:"Āqā ʿAlī Mudarris al-Tihrānī, al-Ḥakīm al-Muʾassis "
     },
     "12":{
        scholarName:"Zayn al-ʿĀbidīn b. Muslim al-Bārfurūshī al-Māzandarānī al-Ḥāʾirī ",
        death:"(d. 1309/1891)",
        sortingKey:"(d. 1309/1891)"
     },
     "13":{
        sortingKey:"(d. 1309/1891)",
        scholarName:"Muḥammad ʿAlī al-Kashmīrī ",
        death:"(d. 1309/1891)"
     },
     "14":{
        scholarName:"Mullā Ḥusaynqulī b. Ramaḍān al-Shawandī al-Hamadānī al-Najafī, Mullā Ḥusaynqulī al-Hamadānī",
        death:"(d. 1311/1893)",
        sortingKey:"(d. 1311/1893)"
     },
     "15":{
        scholarName:"al-Sayyid Muḥammad al-Ḥasan al-Ḥusaynī, al-Mīrzā al-Shirāzī, Mīrzā-i Buzurg, Mīrzā-i Mujaddid ",
        death:"(d. 1312/1894)",
        sortingKey:"(d. 1312/1894)"
     },
     "16":{
        death:"(d. 1312/1894)",
        sortingKey:"(d. 1312/1894)",
        scholarName:"al-Mīrzā Muḥammad Taqī b. Muḥammad al-Tabrīzī al-Māmaqānī, Nayyir "
     },
     "17":{
        sortingKey:"(d. 1312/1894)",
        scholarName:"al-Shaykh al-Mīrzā Ḥabībullāh b. Muḥammad ʿAlī Khān al-Qūchānī al-Gīlānī al-Rashtī al-Najafī, al-Mīrzā Ḥabībullāh al-Rashtī",
        death:"(d. 1312/1894)"
     },
     "18":{
        death:"(d. 1312/1894)",
        sortingKey:"(d. 1312/1894)",
        scholarName:"ʿAlī Muḥammad b. Muḥammad b. Dildār ʿAlī al-Naqawī al-Naṣīrābādī, Tāj al-ʿUlamāʾ "
     },
     "19":{
        death:"(d. 1313/1895)",
        sortingKey:"(d. 1313/1895)",
        scholarName:"al-Sayyid Muḥammad Bāqir al-Khwānsārī, Ṣāḥib Rawḍāt "
     },
     "20":{
        sortingKey:"(d. 1313/1896)",
        scholarName:"Muḥammad Ḥasan Khān Ṣanīʿ al-Dawla, Iʿtimād al-dawla ",
        death:"(d. 1313/1896)"
     },
     "21":{
        death:"(d. 1314/1896)",
        sortingKey:"(d. 1314/1896)",
        scholarName:"Sayyid Abū al-Ḥasan al-Ṭabāṭabāʾī, Mīrzā Abū al-Ḥasan Jilweh "
     },
     "22":{
        sortingKey:"(d. 1314/1896)",
        scholarName:"Mullā Muḥammad Bāqir al-Fishārakī ",
        death:"(d. 1314/1896)"
     },
     "23":{
        scholarName:"Muḥammad b. Muḥammad Mahdī al-Māzandarānī al-Bārfurūshī, Ḥujjat Ashrafī, Ḥājī Ashrafī, Ḥujjat al-Islām ",
        death:"(d. 1315/1897)",
        sortingKey:"(d. 1315/1897)"
     },
     "24":{
        death:"(d. 1315/1897)",
        sortingKey:"(d. 1315/1897)",
        scholarName:"al-Shaykh Abū al-Maʿālī Muḥammad b. Muḥammad b. Ibrāhīm b. Muḥammad al-Kalbāsī al-Iṣfahānī "
     },
     "25":{
        death:"(d. 1315/1897)",
        sortingKey:"(d. 1315/1897)",
        scholarName:"Aḥmad b. Ṣāliḥ al-Baḥrānī "
     },
     "26":{
        scholarName:"Mīrzā Abū al-Faḍl al-Tihrānī, Mīrzā Abū al-Faḍl al-Mujtahid al-Kalāntar, Abū al-Faḍl al-Nūrī ",
        death:"(d. 1316/1898)",
        sortingKey:"(d. 1316/1898)"
     },
     "27":{
        sortingKey:"(d. 1318/1900)",
        scholarName:"al-Sayyid Muḥammad Hāshim Khwānsārī, al-Mīrzā Muḥammad Hāshim b. Zayn al-ʿĀbidīn al-Khwānsārī al-Chahārsūqī ",
        death:"(d. 1318/1900)"
     },
     "28":{
        sortingKey:"(d. 1319/1901)",
        scholarName:"Mīrzā Muḥammad Ḥasan al-Āshtiyānī ",
        death:"(d. 1319/1901)"
     },
     "29":{
        death:"(d. 1319/1901)",
        sortingKey:"(d. 1319/1901)",
        scholarName:"ʿAlī b. ʿAbdullāh b. ʿAlī al-Baḥrānī "
     },
     "30":{
        death:"(d. 1320/1902)",
        sortingKey:"(d. 1320/1902)",
        scholarName:"al-Shaykh al-Mīrzā al-Ḥusayn b. Muḥammad Taqī b. ʿAlī Muḥammad al-Nūrī al-Ṭabarsī, al-Mīrzā Ḥusayn al-Nūrī, al-Muḥaddith al-Nūrī, Hājī Nūrī "
     },
     "33":{
        scholarName:"al-Shaykh Ḥasan ʿAli al-Nukhūdakī al-Iṣfahānī ",
        death:"(d. 1321/1903)",
        sortingKey:"(d. 1321/1903)"
     },
     "34":{
        death:"(d. 1322/1904)",
        sortingKey:"(d. 1322/1904)",
        scholarName:"al-Shaykh Āqā Riḍā b. Muḥammad Hādī al-Hamadānī al-Najafī"
     },
     "35":{
        sortingKey:"(d. 1324/1906)",
        scholarName:"al-Sayyid Muḥammad Mahdī al-Khwānsārī ",
        death:"(d. 1324/1906)"
     },
     "36":{
        sortingKey:"(d. 1324/1906)",
        scholarName:"Mīrzā Ḥabībullāh b. Muḥammad al-Hāshimī al-Musawī al-Khūʾī, Amīn al-Raʿāyā ",
        death:"(d. 1324/1906)"
     },
     "37":{
        sortingKey:"(d. 1325/1907)",
        scholarName:"Mullā Ḥusaynqulī al-Hamadānī, Muḥammad Bahārī ",
        death:"(d. 1325/1907)"
     },
     "38":{
        sortingKey:"(d. 1326/1908)",
        scholarName:"al-Sayyid Muḥammad b. al-Sayyid Muḥāmmad Taqī b. al-Sayyid Muḥammad Riḍā b. al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm ",
        death:"(d. 1326/1908)"
     },
     "39":{
        sortingKey:"(d. 1326/1908)",
        scholarName:"al-Ḥājj al-Mīrzā Ḥusayn b. al-Mīrzā Khalīl b. ʿAlī b. Ibrāhīm al-Tihrānī",
        death:"(d. 1326/1908)"
     },
     "40":{
        death:"(d. 1327/1909)",
        sortingKey:"(d. 1327/1909)",
        scholarName:"al-Shaykh Faḍlullāh Nūrī, Faḍlullāh al-Kajūrī "
     },
     "41":{
        sortingKey:"(d. 1327/1909)",
        scholarName:"Mīrzā Ḥabībullāh al-Shahīdī, Ḥabīb Khurāsānī ",
        death:"(d. 1327/1909)"
     },
     "42":{
        sortingKey:"(d. 1328/1910)",
        scholarName:"al-Mīrzā Jahāngīr Khān al-Qashqāʾī ",
        death:"(d. 1328/1910)"
     },
     "43":{
        death:"(d. 1328/1910)",
        sortingKey:"(d. 1328/1910)",
        scholarName:"Mullā Qurbān ʿAlī Zanjānī, Ḥujjat al-Islām "
     },
     "44":{
        scholarName:"al-Shaykh Mullā Muḥammad Kāẓim b. Mullā Ḥusayn al-Harawī al-Khurāsānī al-Najafī, al-Ākhūnd al-Khurāsānī ",
        death:"(d. 1329/1911) ",
        sortingKey:"(d. 1329/1911) "
     },
     "45":{
        death:"(d. 1329/1911)",
        sortingKey:"(d. 1329/1911)",
        scholarName:"Mullā Abū Ṭālib al-Arākī "
     },
     "46":{
        sortingKey:"(d. 1329/1911)",
        scholarName:"Muḥammad Shafīʾ al-Būshahrī ",
        death:"(d. 1329/1911)"
     },
     "47":{
        death:"(d. 1330/1912) ",
        sortingKey:"(d. 1330/1912) ",
        scholarName:"Mīrzā ʿAlī Thiqat al-Islām al-Tabrīzī "
     },
     "48":{
        scholarName:"Muḥammad Taqī b. Muḥammad Bāqir, Āqā al-Najafī al-Iṣfahānī ",
        death:"(d. 1332/1914)",
        sortingKey:"(d. 1332/1914)"
     },
     "49":{
        sortingKey:"(d. 1333/1915)",
        scholarName:"al-Ākhūnd Mullā Muḥammad al-Kāshānī, Ākhūnd-i Kāshī ",
        death:"(d. 1333/1915)"
     },
     "50":{
        sortingKey:"(d. 1333/1915)",
        scholarName:"al-Sayyid Muḥammad Saʿīd al-Ḥabbūbī, al-Ḥabbūbī al-Kabīr ",
        death:"(d. 1333/1915)"
     },
     "51":{
        death:"(d. 1333/1915)",
        sortingKey:"(d. 1333/1915)",
        scholarName:"ʿAlī b. Zayn al-ʿĀbidīn al-Pārchīnī al-Yazdī al-Ḥāʾirī "
     },
     "52":{
        scholarName:"al-Mīrzā Muḥammad ʿAlī b. Muḥammad Naṣīr al-Gīlānī al-Chahārdihī ",
        death:"(d. 1334/1916)",
        sortingKey:"(d. 1334/1916)"
     },
     "53":{
        sortingKey:"(d. 1336/1918)",
        scholarName:"al-Sayyid ʿAlī al-Tabrīzī, al-Sayyid ʿAlī Dāmād ",
        death:"(d. 1336/1918)"
     },
     "54":{
        sortingKey:"(d. 1337/1919)",
        scholarName:"al-Sayyid Muḥammad Kāẓim al-Ṭabāṭabāʾī al-Yazdī, Ṣāḥib ʿUrwat al-wuthqā ",
        death:"(d. 1337/1919)"
     },
     "55":{
        death:"(d. 1338/1919)",
        sortingKey:"(d. 1338/1919)",
        scholarName:"al-Mīrzā Muḥammad Taqī al-Shirāzī, Mīrzā-i duwuum, Mīrzā-i kuchak "
     },
     "56":{
        sortingKey:"(d. 1338/1919)",
        scholarName:"al-Sayyid Ismāʿīlī b. Ṣadr al-Dīn al-Musawī al-Āmilī",
        death:"(d. 1338/1919)"
     },
     "57":{
        scholarName:"al-Shaykh Fatḥullāh b. Muḥammad Jawād al-Namāzī al-Gharawī al-Shirāzī al-Iṣfahānī, Sharīʿatmadār, al-Shaykh al-Sharīʿa al-Iṣfahānī",
        death:"(d. 1339/1920)",
        sortingKey:"(d. 1339/1920)"
     },
     "58":{
        scholarName:"Mullā ʿAbd al-Karīm al-Gizzī, al-Ākhūnd al-Ghizzī ",
        death:"(d. 1339/1921)",
        sortingKey:"(d. 1339/1921)"
     },
     "59":{
        sortingKey:"(d. 1340/1922)",
        scholarName:"Mullā Ḥabibullāh Sharīf al-Kāshānī ",
        death:"(d. 1340/1922)"
     },
     "60":{
        death:"(d. 1340/1922)",
        sortingKey:"(d. 1340/1922)",
        scholarName:"ʿAlī b. al-Ḥasan b. ʿAlī b. Sulaymān al-Bilādī al-Baḥrānī "
     },
     "61":{
        scholarName:"al-Sayyid Muḥammad Bāqir al-Durchehī ",
        death:"(d. 1342/1923)",
        sortingKey:"(d. 1342/1923)"
     },
     "62":{
        scholarName:"al-Shaykh Mahdī al-Khāliṣī al-Kāẓimī ",
        death:"(d. 1343/1924)",
        sortingKey:"(d. 1343/1924)"
     },
     "63":{
        sortingKey:"(d. 1344/1925)",
        scholarName:"Āqā Mīrzā ʿAlī Akbar al-Ḥikamī al-Yazdī, Ḥakīm Ilāhī ",
        death:"(d. 1344/1925)"
     },
     "64":{
        death:"(d. 1344/1925)",
        sortingKey:"(d. 1344/1925)",
        scholarName:"Muḥammad Maʿṣūm Nāʾib al-Ṣadr al-Shīrāzī "
     },
     "65":{
        scholarName:"al-Mīrzā Muḥammad ʿAlī Akbar al-Ḥakamī al-Yazdī ",
        death:"(d. 1345/1926)",
        sortingKey:"(d. 1345/1926)"
     },
     "66":{
        sortingKey:"(d. 1346/1927)",
        scholarName:"ʿAbd al-ʿAlī b. Jaʿfar al-Khwānsārī, Abū Turāb al-Khwānsārī ",
        death:"(d. 1346/1927)"
     },
     "67":{
        death:"(d. 1348/1929)",
        sortingKey:"(d. 1348/1929)",
        scholarName:"Shʿbān al-Gīlānī "
     },
     "68":{
        scholarName:"Afḍal al-Mulk al-Mīrzā Ghulām Ḥusayn Khān al-Shīrāzī ",
        death:"(d. 1348/1929)",
        sortingKey:"(d. 1348/1929)"
     },
     "69":{
        scholarName:"ʿAbdullāh b. Muḥammad Ḥasan al-Māmaqānī, al-ʿAllāma al-Māmaqānī ",
        death:"(d. 1351/1933)",
        sortingKey:"(d. 1351/1933)"
     },
     "70":{
        scholarName:"Muḥammad Jawād al-Balāghī al-Najafī ",
        death:"(d. 1352/1933)",
        sortingKey:"(d. 1352/1933)"
     },
     "71":{
        sortingKey:"(d. 1353/1934)",
        scholarName:"al-Sayyid Abū al-Qāsim al-Dihkurdī al-Iṣfahānī ",
        death:"(d. 1353/1934)"
     },
     "72":{
        sortingKey:"(d. 1354/1935)",
        scholarName:"al-Sayyid Ḥasan al-Ṣadr ",
        death:"(d. 1354/1935)"
     },
     "73":{
        death:"(d. 1355/1937)",
        sortingKey:"(d. 1355/1937)",
        scholarName:"ʿAbd al-Karīm al-Ḥāʾīrī al-Yazdī "
     },
     "74":{
        scholarName:"Muḥammad Ḥusayn al-Gharawī al-Nāʾīnī ",
        death:"(d. 1355/1937)",
        sortingKey:"(d. 1355/1937)"
     },
     "75":{
        scholarName:"al-Sayyid Ḥasan al-Mudarris ",
        death:"(d. 1356/1937)",
        sortingKey:"(d. 1356/1937)"
     },
     "76":{
        death:"(d. 1359/1940)",
        sortingKey:"(d. 1359/1940)",
        scholarName:"ʿAbbās b. Muḥāmmad Riḍā al-Qummī, al-Shaykh ʿAbbās al-Qummī "
     },
     "77":{
        death:"(d. 1358/1940)",
        sortingKey:"(d. 1358/1940)",
        scholarName:"Muḥammad Mahdī al-Ḥāʾirī al-Māzandarānī "
     },
     "78":{
        death:"(d. 1360/1941)",
        sortingKey:"(d. 1360/1941)",
        scholarName:"Muḥammad Ṭāhir al-Tunikābunī "
     },
     "79":{
        scholarName:"al-Sayyid Abū al-Ḥasan al-Ḥāfiziyān ",
        death:"(d. 1360/1941)",
        sortingKey:"(d. 1360/1941)"
     },
     "80":{
        sortingKey:"(d. 1361/1942)",
        scholarName:"Muḥammad Ḥusayn al-Gharawī al-Iṣfahānī, Kumpānī ",
        death:"(d. 1361/1942)"
     },
     "81":{
        scholarName:"al-Sayyid Nāṣir Ḥusayn al-Musawī, Nāṣir al-millat ",
        death:"(d. 1361/1942)",
        sortingKey:"(d. 1361/1942)"
     },
     "82":{
        sortingKey:"(d. 1361/1942)",
        scholarName:"Ḥasan ʿAlī al-Nukhūdakī al-Iṣfahānī ",
        death:"(d. 1361/1942)"
     },
     "83":{
        sortingKey:"(d. 1363/1940)",
        scholarName:"al-Shaykh Mūsā b. Muḥammad al-Najafī al-Khwānsārī ",
        death:"(d. 1363/1940)"
     },
     "84":{
        sortingKey:"(d. 1363/1940)",
        scholarName:"al-Shaykh Murtaḍā al-Ṭāliqānī ",
        death:"(d. 1363/1940)"
     },
     "85":{
        sortingKey:"(d. 1363/1940)",
        scholarName:"ʿAlī b. al-Ḥasan al-Khunayzī ",
        death:"(d. 1363/1940)"
     },
     "86":{
        death:"(d. 1365/1946)",
        sortingKey:"(d. 1365/1946)",
        scholarName:"al-Mīrzā Muḥammad Mahdī al-Gharawī al-Iṣfahānī al-Khurāsānī, al-Mīrzā Mahdī al-Iṣfahānī "
     },
     "87":{
        death:"(d. 1365/1946)",
        sortingKey:"(d. 1365/1946)",
        scholarName:"al-Sayyid Abū al-Ḥasan al-Iṣfahānī "
     },
     "88":{
        death:"(d. 1365/1946)",
        sortingKey:"(d. 1365/1946)",
        scholarName:"al-Sayyid ʿAlī al-Qādī al-Ṭabāṭabāʾī "
     },
     "89":{
        scholarName:"al-Shaykh Muḥammad ʿAlī al-Kāẓimī al-Khurāsānī ",
        death:"(d. 1365/1946)",
        sortingKey:"(d. 1365/1946)"
     },
     "90":{
        sortingKey:"(d. 1365/1946)",
        scholarName:"al-Shaykh Muḥammad Ḥirz al-Dīn ",
        death:"(d. 1365/1946)"
     },
     "91":{
        sortingKey:"(d. 1366/1947)",
        scholarName:"al-Sayyid Ḥusayn al-Ṭabāṭabāʾī al-Qummī, Ḥāj Āqā Ḥusayn al-Qummī, al-Āqā Ḥusayn al-Qummī ",
        death:"(d. 1366/1947)"
     },
     "92":{
        scholarName:"Mullā ʿAlī al-Tabrīzī, al-Wāʿiẓ al-Khayābānī ",
        death:"(d. 1367/1948)",
        sortingKey:"(d. 1367/1948)"
     },
     "93":{
        sortingKey:"(d. 1367/1947)",
        scholarName:"Muḥammad Amīn al-Imāmī al-Khūʾī ",
        death:"(d. 1367/1947)"
     },
     "94":{
        sortingKey:"(d. 1368/1949)",
        scholarName:"Muḥammad ʿAlī Baydābādī, al-Shāhābādī ",
        death:"(d. 1368/1949)"
     },
     "95":{
        sortingKey:"(d. 1371/1952)",
        scholarName:"al-Sayyid Muḥsin al-Amīn al-Ḥusaynī al-ʿĀmilī ",
        death:"(d. 1371/1952)"
     },
     "96":{
        sortingKey:"(d. 1371/1952)",
        scholarName:"al-Sayyid Muḥammad Taqī al-Khwānsārī ",
        death:"(d. 1371/1952)"
     },
     "97":{
        sortingKey:"(d. 1372/1953)",
        scholarName:"al-Sayyid Muḥammad Ḥujjat al-Kūhkamariʾī ",
        death:"(d. 1372/1953)"
     },
     "98":{
        sortingKey:"(d. 1372/1953)",
        scholarName:"Ḥaydar Qulī Sardār al-Kābulī ",
        death:"(d. 1372/1953)"
     },
     "99":{
        scholarName:"Mīrzā Mahdī al-Āshtiyānī ",
        death:"(d. 1372/1952)",
        sortingKey:"(d. 1372/1952)"
     },
     "100":{
        scholarName:"al-Sayyid Muḥammad ʿAlī b. Ismāʿīl al-Ṣadr, al-Sayyid Ṣadr al-Dīn al-Ṣadr ",
        death:"(d. 1373/1953)",
        sortingKey:"(d. 1373/1953)"
     },
     "101":{
        sortingKey:"(d. 1373/1954)",
        scholarName:"Muḥammad al-Ḥusayn Āl Kāshif al-Ghiṭāʾ ",
        death:"(d. 1373/1954)"
     },
     "102":{
        death:"(d. 1373/1954)",
        sortingKey:"(d. 1373/1954)",
        scholarName:"Sayyid Muḥammad ʿAlī b. Ismāʿīl al-Ṣadr, Sayyid Ṣadr al-Dīn al-Ṣadr "
     },
     "103":{
        sortingKey:"(d. 1373/1954)",
        scholarName:"Mīrzā Muḥammad ʿAlī al-Mudarris al-Tabrīzī, al-Mudarris al-Khayābānī ",
        death:"(d. 1373/1954)"
     },
     "104":{
        sortingKey:"(d. 1375/1956)",
        scholarName:"Ḍiyāʾ al-Dīn Durri al-Iṣfahānī ",
        death:"(d. 1375/1956)"
     },
     "105":{
        sortingKey:"(d. 1377/1957)",
        scholarName:"al-Sayyid Jamāl al-Dīn al-Gulpaygānī ",
        death:"(d. 1377/1957)"
     },
     "106":{
        sortingKey:"(d. 1377/1957)",
        scholarName:"al-Sayyid ʿAbd al-Ḥusayn Sharaf al-Dīn al-Musawī al-ʿĀmilī ",
        death:"(d. 1377/1957)"
     },
     "107":{
        scholarName:"al-Sayyid Ḥusayn al-Ṭabāṭabāʾī al-Burūjirdī ",
        death:"(d. 1380/1960)",
        sortingKey:"(d. 1380/1960)"
     },
     "108":{
        sortingKey:"(d. 1380/1960)",
        scholarName:"al-Shaykh Hāshim Mudarris al-Qazwīnī, al-Shaykh Hāshim al-Qazwīnī ",
        death:"(d. 1380/1960)"
     },
     "109":{
        sortingKey:"(d. 1380/1960)",
        scholarName:"Muḥammad Ḥasan al-Ḥāʾirī al-Qazwīnī ",
        death:"(d. 1380/1960)"
     },
     "110":{
        sortingKey:"(d. 1380/1960)",
        scholarName:"Muḥammad ʿAlī al-Ḥijāzī ",
        death:"(d. 1380/1960)"
     },
     "111":{
        death:"(d. 1382/1962)",
        sortingKey:"(d. 1382/1962)",
        scholarName:"al-Sayyid ʿAbd al-Hādī al-Shīrāzī "
     },
     "112":{
        scholarName:"al-Shaykh Muḥammad Riḍā al-Muẓaffar ",
        death:"(d. 1383/1963)",
        sortingKey:"(d. 1383/1963)"
     },
     "113":{
        sortingKey:"(d. 1383/1963)",
        scholarName:"al-Sayyid Muḥammad b. ʿAbdullāh al-Bihbihānī ",
        death:"(d. 1383/1963)"
     },
     "114":{
        sortingKey:"(d. 1384/1964)",
        scholarName:"Muḥammad Bāqir b. Muḥammad Taqī Āqā Najafī al-Iṣfahānī, Ulfat ",
        death:"(d. 1384/1964)"
     },
     "115":{
        sortingKey:"(d. 1386/1966)",
        scholarName:"al-Sayyid Muḥammad ʿAlī al-Ḥusaynī al-Shahristānī, Hibat al-Dīn al-Shahristānī ",
        death:"(d. 1386/1966)"
     },
     "116":{
        death:"(d. 1386/1967)",
        sortingKey:"(d. 1386/1967)",
        scholarName:"al-Shaykh Mujtabā al-Qazwīnī "
     },
     "117":{
        sortingKey:"(d. 1386/1967)",
        scholarName:"Mīrzā Ḥusayn Faqīh al-Sabzawārī ",
        death:"(d. 1386/1967)"
     },
     "118":{
        death:"(d. 1388/1969)",
        sortingKey:"(d. 1388/1969)",
        scholarName:"al-Sayyid Muḥammad al-Muḥaqqiq Dāmād "
     },
     "119":{
        sortingKey:"(d. 1389/1970)",
        scholarName:"Muḥammad Muḥsin b. ʿAlī al-Munzawī al-Tihrānī, Āgha Buzurg al-Tihrānī ",
        death:"(d. 1389/1970)"
     },
     "120":{
        death:"(d. 1390/1970)",
        sortingKey:"(d. 1390/1970)",
        scholarName:"ʿAbdul Ḥusayn al-Amīnī, al-ʿAllāmā al-Amīnī "
     },
     "121":{
        scholarName:"al-Sayyid Muḥsin al-Ṭabāṭabāʾī al-Ḥakīm ",
        death:"(d. 1390/1970)",
        sortingKey:"(d. 1390/1970)"
     },
     "122":{
        sortingKey:"(d. 1391/1970)",
        scholarName:"al-Sayyid Muḥammad Mahdī al-Iṣfahānī al-Kāẓimī ",
        death:"(d. 1391/1970)"
     },
     "123":{
        death:"(d. 1391/1971)",
        sortingKey:"(d. 1391/1971)",
        scholarName:"al-Shaykh Muḥammad Taqī al-Āmūlī "
     },
     "124":{
        death:"(d. 1391/1971)",
        sortingKey:"(d. 1391/1971)",
        scholarName:"Muḥammad Ṣāliḥ al-Ḥāʾirī al-Māzandarānī "
     },
     "125":{
        sortingKey:"(d. 1393/1973)",
        scholarName:"Abū al-Ḥasan al-Shaʿrānī, al-ʿAllāma al-Shaʿrānī ",
        death:"(d. 1393/1973)"
     },
     "126":{
        death:"(d. 1394/1974)",
        sortingKey:"(d. 1394/1974)",
        scholarName:"al-Sayyid Maḥmūd al-Ḥusaynī al-Shāhrūdī "
     },
     "127":{
        death:"(d. 1394/1974)",
        sortingKey:"(d. 1394/1974)",
        scholarName:"Ḥāj Āghā Raḥīm Arbāb, Raḥīm Arbāb "
     },
     "128":{
        scholarName:"al-Shaykh Ḥusayn al-Ḥillī ",
        death:"(d. 1394/1974)",
        sortingKey:"(d. 1394/1974)"
     },
     "129":{
        sortingKey:"(d. 1395/1975)",
        scholarName:"al-Sayyid Muḥammad Hādī al-Ḥusaynī al-Mīlānī ",
        death:"(d. 1395/1975)"
     },
     "130":{
        scholarName:"al-Sayyid Abū al-Ḥasan al-Rafīʿī al-Qazwīnī ",
        death:"(d. 1395/1975)",
        sortingKey:"(d. 1395/1975)"
     },
     "131":{
        death:"(d. 1395/1975)",
        sortingKey:"(d. 1395/1975)",
        scholarName:"Mīrzā Aḥmad al-Āshtiyānī "
     },
     "132":{
        death:"(d. 1395/1975)",
        sortingKey:"(d. 1395/1975)",
        scholarName:"al-Sayyid Muḥammad Kāẓim al-ʿAṣṣār "
     },
     "133":{
        sortingKey:"(d. 1396/1976)",
        scholarName:"al-Sayyid Muḥammad al-Ḥasan al-Musawī al-Bujnūrdī ",
        death:"(d. 1396/1976)"
     },
     "134":{
        death:"(d. 1396/1976)",
        sortingKey:"(d. 1396/1976)",
        scholarName:"Niʿmatullāh al-Ṣāliḥī al-Najafābādī "
     },
     "135":{
        sortingKey:"(d. 1396/1976)",
        scholarName:"Mīrzā Muḥammad ʿAlī al-Ḥabībābādī, Muʿallim-i Ḥabībābādī ",
        death:"(d. 1396/1976)"
     },
     "136":{
        sortingKey:"(d. 1398/1977)",
        scholarName:"al-Sayyid Muṣṭafā al-Khumaynī ",
        death:"(d. 1398/1977)"
     },
     "137":{
        sortingKey:"(d. 1399/1978)",
        scholarName:"al-Sayyid Mūsā al-Ṣadr ",
        death:"(fl. 1399/1978)"
     },
     "138":{
        sortingKey:"(d. 1399/1979)",
        scholarName:"al-Sayyid Muḥammad ʿAlī al-Qāḍī al-Ṭabāṭabāʾī ",
        death:"(d. 1399/1979)"
     },
     "139":{
        sortingKey:"(d. 1399/1979)",
        scholarName:"Murtaḍā Muṭahharī, al-Shahīd al- Muṭahharī ",
        death:"(d. 1399/1979)"
     },
     "140":{
        scholarName:"al-Sayyid Jalāl al-Dīn al-Ḥusaynī al-Urmawī, al-Muḥaddith al-Urmawī ",
        death:"(d. 1399/1979)",
        sortingKey:"(d. 1399/1979)"
     },
     "141":{
        sortingKey:"(d. 1400/1979)",
        scholarName:"Muḥammad Mufattiḥ, Shahīd Mufattiḥ ",
        death:"(d. 1400/1979)"
     },
     "142":{
        sortingKey:"(d. 1400/1980)",
        scholarName:"al-Sayyid Muḥammad Bāqir al-Ṣadr ",
        death:"(d. 1400/1980)"
     },
     "143":{
        sortingKey:"(d. 1400/1980)",
        scholarName:"al-Sayyid Ḥasan al-Ḥusaynī al-Lawāsānī ",
        death:"(d. 1400/1980)"
     },
     "155":{
        sortingKey:"(d. 1351/1932)",
        scholarName:"al-Shaykh ʿAbbās b. al-Shaykh ʿAlī b. al-Shaykh Jaʿfar Kāshif al-Ghiṭāʾ",
        death:"(d. 1351/1932)"
     },
     "156":{
        scholarName:"al-Sayyid Abū al-Qāsim b. Ḥasan b. Muḥammad al-Mujāhid al-Ṭabāṭabāʾī",
        death:"(d. 1309/1891)",
        sortingKey:"(d. 1309/1891)"
     },
     "159":{
        sortingKey:"(d. 1343/1925)",
        scholarName:"End of the Qajar rule in Iran (1192-1343/1779-1925)",
        death:"(1343/1925)",
        color:"#eeddbb"
     },
     "160":{
        sortingKey:"(d. 1323/1905)",
        scholarName:"al-Shaykh Muḥammad Ḥasan b. ʿAbdullāh b. Muḥammad Bāqir al-Māmaqānī al-Turkī al-Najafī",
        death:"(d. 1323/1905)",
        color:""
     },
     "163":{
        sortingKey:"(d. 1339/1920)",
        scholarName:"al-Shaykh Ḥusayn b. Zayn al-ʿĀbidīn al-Māzandarānī",
        death:"(d. 1339/1920)",
        color:""
     },
     "164":{
        scholarName:"al-Shaykh Luṭfullāh al-Māzandarānī al-Najafī",
        death:"(d. 1313/1895)",
        color:"",
        sortingKey:"(d. 1313/1895)"
     },
     "165":{
        sortingKey:"(d. 1306/1888)",
        scholarName:"al-Shaykh Mullā Muḥammad Bāqir al-Īrawānī al-Turkī al-Najafī",
        death:"(d. 1306/1888)",
        color:""
     },
     "167":{
        scholarName:"al-Sayyid Murtaḍā Mahdī b. Muḥammad b. Karamullāh al-Raḍawī al-Qummī al-Kashmīrī",
        death:"(d. 1323/1904)",
        color:"",
        sortingKey:"(d. 1323/1904)"
     },
     "168":{
        sortingKey:"(d. 1322/1904)",
        scholarName:"al-Shaykh ʿAlī b. Fatḥullāh al-Nahāwandī al-Najafī",
        death:"(d. 1322/1904)",
        color:""
     },
     "169":{
        death:"(d. 1316/1897)",
        color:"",
        sortingKey:"(d. 1316/1897)",
        scholarName:"al-Sayyid Muḥammad b. Qāsim al- Ṭabāṭabāʾī al-Fishārakī al-Iṣfahānī"
     },
     "170":{
        sortingKey:"(d. 1330/1912)",
        scholarName:"al-Shaykh ʿAbdullāh b. Nāṣir al-Ṭabarsī al-Māzandarānī",
        death:"(d. 1330/1912)",
        color:""
     },
     "171":{
        scholarName:"al-Shaykh Muḥammad Ṭāhā b. Mahdī b. Muḥammad Riḍā b. Muḥammad b. al-Ḥājj Najaf al-Tabrīzī",
        death:"(d. 1323/1905)",
        color:"",
        sortingKey:"(d. 1323/1905)"
     },
     "188":{
        scholarName:"al-Shaykh ʿAbbās b. al-Shaykh Ḥasan b. Jaʿfar Kāshif al-Ghiṭāʿ",
        death:"(d. 1323/1905)",
        sortingKey:"(d. 1323/1905)"
     },
     "189":{
        death:"(d. 1335/1916)",
        sortingKey:"(d. 1335/1916)",
        scholarName:"al-Shaykh Ḥasan Aḥmad b. ʿAbd al-Ḥusayn al-Jawāhirī"
     },
     "199":{
        "sortingKey ":"(d. 1302/1881)",
        death:"(d. 1302/1881)",
        scholarName:"al-Shaykh Ḥasan b. Muḥammad Ismāʿīl b. Abū Ṭālib al-Ardakānī"
     },
     "201":{
        sortingKey:"(d. 1351/1938)",
        scholarName:"al-Sayyid Najm al-Ḥasan, Najm al-millat ",
        death:"(d. 1351/1938)"
     },
     "202":{
        sortingKey:"(d. 1362/1943)",
        scholarName:"Ghulām ʿAlī Ismāʿīl, ʿAllāma Ḥājī Nājī ",
        death:"(d. 1362/1943)"
     },
     "210":{
        sortingKey:"(d. 1366/1947)",
        scholarName:"al-Sayyid Aḥmad al-Hindī",
        death:"(d. 1366/1947)"
     },
     "212":{
        death:"(1322/1905)",
        color:"#eeddbb",
        sortingKey:"(d. 1322/1905)",
        scholarName:"Beginning of the Iranian Constitutional Revolution (1322-1329/1905-1911)"
     },
     "215":{
        death:"(d. 1326/1908)",
        sortingKey:"(d. 1326/1908)",
        scholarName:"al-Sayyid Muḥammad b. al-Sayyid Muḥammad Taqī b. al-Sayyid Riḍā b. al-Sayyid Muḥammad Mahdī Baḥr al-ʿulūm"
     },
     "222":{
        death:"(d. 1328/1910)",
        sortingKey:"(d. 1328/1910)",
        scholarName:"al-Shaykh ʿAbd al-Ḥasan b. Raḍī al-Najafī"
     },
     "224":{
        death:"(1329/1911)",
        color:"#eeddbb",
        sortingKey:"(d. 1329/1911)",
        scholarName:"End of the Iranian Constitutional Revolution (1322-1329/1905-1911)"
     },
     "232":{
        scholarName:"al-Shaykh Hādī b. Mullā Muḥammad Amīn al-Wāʿiẓ al-Tihrānī al-Najafī",
        death:"(d. 1321/1903)",
        sortingKey:"(d. 1321/1903)"
     },
     "233":{
        sortingKey:"(d. 1320/1902)",
        scholarName:"al-Sayyid Muḥammad Jaʿfar b. ʿAlī Naqī b. Ḥasan b. Muḥammad al-Mujāhid al-Ṭabāṭabāʾī ",
        death:"(d. 1320/1902)"
     },
     "234":{
        sortingKey:"(d. 1315/1898)",
        scholarName:"al-Sayyid al-Mīrzā Ḍiyāʾ al-Dīn Muḥammad Ḥusayn b. Amīr Muḥammad ʿAlī b. Amīr Muḥammad Ḥusayn al-Shahristānī ",
        death:"(d. 1315/1898)"
     },
     "235":{
        sortingKey:"(d. 1308/1890)",
        scholarName:"al-Shaykh Muḥammad Ḥusayn b. Hāshim al-ʿĀmilī al-Kāzimī al-Najafī",
        death:"(d. 1308/1890)"
     },
     "244":{
        sortingKey:"(d. 1300/1882)",
        scholarName:"al-Sayyid Mahdī b. Ḥasan b. Aḥmad Ḥusaynī al-Qazwīnī al-Najafī al-Ḥillī",
        death:"(d. 1300/1882)"
     },
     "289":{
        sortingKey:"(d. 1331/1912)",
        scholarName:"al-Sayyid Muḥammad Bāqir b. Abū al-Qāsim b. Āqā Ḥusayn b. Muḥammad al-Mujāhid al-Ṭabāṭabāʾī",
        death:"(d. 1331/1912)"
     },
     "298":{
        sortingKey:"(d. 1341/1923)",
        scholarName:"End of the Ottoman Empire (c. 698-1341/1299-1923)",
        death:"(1341/1923)",
        color:"#eeddbb"
     },
     "301":{
        death:"(1399/1979)",
        color:"#eeddbb",
        sortingKey:"(d. 1399/1979)",
        scholarName:"Iranian Revolution and establishment of Islamic Republic of Iran (1399/1979)"
     }
  },
  "15":{
     "0":{
        sortingKey:"(d. 1402/1981)",
        scholarName:"al-Sayyid Muḥammad Ḥusayn al-Ṭabāṭabāʾī, al-ʿAllāma al-Ṭabāṭabāʾī ",
        death:"(d. 1402/1981)"
     },
     "1":{
        sortingKey:"(d. 1402/1982)",
        scholarName:"ʿAṭāullāh al-Ashrafī al-Iṣfahānī ",
        death:"(d. 1402/1982)"
     },
     "2":{
        sortingKey:"(d. 1402/1982)",
        scholarName:"ʿAbd al-Raḥīm al-Rabbānī al-Shīrāzī ",
        death:"(d. 1402/1982)"
     },
     "3":{
        death:"(d. 1402/1982)",
        sortingKey:"(d. 1402/1982)",
        scholarName:"Muḥammad al-Ṣadūqī "
     },
     "4":{
        death:"(d. 1403/1983)",
        sortingKey:"(d. 1403/1983)",
        scholarName:"al-Sayyida Nuṣrat Baygam Amīn, Bānū Amīn al-Khātūnābādī al-Iṣfahānī "
     },
     "5":{
        scholarName:"al-Sayyid Hāshim al-Musawī al-Ḥaddād ",
        death:"(d. 1404/1983)",
        sortingKey:"(d. 1404/1983)"
     },
     "6":{
        sortingKey:"(d. 1405/1984)",
        scholarName:"al-Sayyid ʿAbdullāh al-Musawī al-Shīrāzī ",
        death:"(d. 1405/1984)"
     },
     "7":{
        scholarName:"al-Sayyid Aḥmad al-Khwānsārī ",
        death:"(d. 1405/1985)",
        sortingKey:"(d. 1405/1985)"
     },
     "8":{
        sortingKey:"(d. 1406/1985)",
        scholarName:"Murtaḍā al-Ḥāʿirī al-Yazdī ",
        death:"(d. 1406/1985)"
     },
     "9":{
        sortingKey:"(d. 1406/1985)",
        scholarName:"Dhabīḥullāh al-Maḥallātī Mushtāq al-ʿAskarī, Dhabīḥullāh al-Maḥallātī ",
        death:"(d. 1406/1985)"
     },
     "10":{
        sortingKey:"(d. 1407/1986)",
        scholarName:"al-Sayyid Muḥammad Kāẓim al-Sharīʿatmadārī ",
        death:"(d. 1407/1986)"
     },
     "11":{
        sortingKey:"(d. 1408/1988)",
        scholarName:"al-Sayyid ʿAlī Naqī al-Naqawī al-Lakhnawī, ʿAllāma Naqqan ",
        death:"(d. 1408/1988)"
     },
     "12":{
        death:"(d. 1409/1989)",
        sortingKey:"(d. 1409/1989)",
        scholarName:"al-Sayyid Rūḥullāh al-Musawī al-Khumaynī "
     },
     "13":{
        death:"(d. 1409/1989)",
        sortingKey:"(d. 1409/1989)",
        scholarName:"al-Mīrzā Jawād Āqā Tihrānī "
     },
     "14":{
        sortingKey:"(d. 1411/1990)",
        scholarName:"al-Sayyid Shihāb al-Dīn al-Marʿashī al-Najafī ",
        death:"(d. 1411/1990)"
     },
     "15":{
        sortingKey:"(d. 1411/1990)",
        scholarName:"Muḥammad Taqī al-Qummī ",
        death:"(d. 1411/1990)"
     },
     "16":{
        sortingKey:"(d. 1413/1992)",
        scholarName:"al-Sayyid Abū al-Qāsim al-Khūʾī ",
        death:"(d. 1413/1992)"
     },
     "17":{
        scholarName:"al-Sayyid Muḥammad Riḍā al-Gulpāygānī ",
        death:"(d. 1414/1993)",
        sortingKey:"(d. 1414/1993)"
     },
     "18":{
        sortingKey:"(d. 1414/1993)",
        scholarName:"al-Sayyid ʿAbd al-Aʿlā al-Mūsawī al-Sabzawārī ",
        death:"(d. 1414/1993)"
     },
     "19":{
        death:"(d. 1413/1993)",
        sortingKey:"(d. 1413/1993)",
        scholarName:"Mīrzā Hāshim al-Āmūlī al-Lārījānī "
     },
     "20":{
        death:"(d. 1415/1994)",
        sortingKey:"(d. 1415/1994)",
        scholarName:"Muḥammad ʿAlī al-Arākī "
     },
     "21":{
        sortingKey:"(d. 1415/1995)",
        scholarName:"al-Sayyid ʿAbd al-ʿAzīz al-Ṭabāṭabāʾī al-Yazdī, al-Muḥaqqiq al-Ṭabāṭabāʾī ",
        death:"(d. 1415/1995)"
     },
     "22":{
        death:"(d. 1416/1996)",
        sortingKey:"(d. 1416/1996)",
        scholarName:"al-Sayyid Muḥammad Ḥusaynī al-Ḥusaynī Lālehzārī, al-ʿAllāmā al-Tihrānī "
     },
     "23":{
        scholarName:"al-Sayyid Muḥammad Ḥusayn al-Mahdavī al-Iṣfahānī ",
        death:"(d. 1416/1996)",
        sortingKey:"(d. 1416/1996)"
     },
     "24":{
        sortingKey:"(d. 1416/1996)",
        scholarName:"Muḥammad Taqī al-Shūshtarī ",
        death:"(d. 1416/1996)"
     },
     "25":{
        death:"(d. 1416/1996)",
        sortingKey:"(d. 1416/1996)",
        scholarName:"al-Shaykh Maḥmūd al-Ḥalabī Zākirzādeh al-Tawallāʾī "
     },
     "26":{
        death:"(d. 1419/1998)",
        sortingKey:"(d. 1419/1998)",
        scholarName:"Muḥammad Taqī b. Karīm al-Jaʿfarī "
     },
     "27":{
        scholarName:"al-Sayyid Muḥammad b. Muḥammad Ṣādiq al-Ṣadr ",
        death:"(d. 1419/1999)",
        sortingKey:"(d. 1419/1999)"
     },
     "28":{
        death:"(d. 1419/1999)",
        sortingKey:"(d. 1419/1999)",
        scholarName:"al-Sayyid ʿAbd al-Karīm al-Raḍawī al-Kashmīrī "
     },
     "29":{
        sortingKey:"(d. 1419/1999)",
        scholarName:"Murtaḍā Mudarris al-Gīlānī ",
        death:"(d. 1419/1999)"
     },
     "30":{
        sortingKey:"(d. 1421/2000)",
        scholarName:"al-Shaykh Muḥammad Sharīf al-Rāzī ",
        death:"(d. 1421/2000)"
     },
     "31":{
        death:"(d. 1423/2002)",
        sortingKey:"(d. 1423/2002)",
        scholarName:"al-Sayyid Muḥammad Taqī al-Ḥakīm "
     },
     "32":{
        death:"(d. 1423/2002)",
        sortingKey:"(d. 1423/2002)",
        scholarName:"al-Sayyid Ḥasan Amīn al-ʿĀmilī "
     },
     "33":{
        sortingKey:"(d. 1425/2004)",
        scholarName:"Hasan ʿAlī b. Muḥammad Riḍā b. Shihāb al-Murwārīd ",
        death:"(d. 1425/2004)"
     },
     "34":{
        scholarName:"al-Sayyid Jalāl al-Dīn al-Āshtiyānī ",
        death:"(d. 1426/2005)",
        sortingKey:"(d. 1426/2005)"
     },
     "35":{
        sortingKey:"(d. 1426/2005)",
        scholarName:"ʿAlī Akbar al-Ghaffārī ",
        death:"(d. 1426/2005)"
     },
     "36":{
        death:"(d. 1427/2006)",
        sortingKey:"(d. 1427/2006)",
        scholarName:"Niʿmatullāh al-Ṣāliḥī al-Najafābādī "
     },
     "37":{
        death:"(d. 1430/2009)",
        sortingKey:"(d. 1430/2009)",
        scholarName:"Ḥusayn ʿAlī al-Muntaẓarī "
     },
     "38":{
        scholarName:"Muḥammad Taqī al-Bihjat al-Fūmānī ",
        death:"(d. 1430/2009)",
        sortingKey:"(d. 1430/2009)"
     },
     "39":{
        sortingKey:"(d. 1431/2010)",
        scholarName:"Muḥammad Riḍā al-Jaʿfarī al-Ishkawarī ",
        death:"(d. 1431/2010)"
     },
     "40":{
        death:"(d. 1431/2010)",
        sortingKey:"(d. 1431/2010)",
        scholarName:"al-Sayyid Muḥammad Ḥusayn Faḍlullāh "
     },
     "41":{
        death:"(d. 1432/2011)",
        sortingKey:"(d. 1432/2011)",
        scholarName:"al-Shaykh Jawād b. ʿAbbās al-Karbalāʾī "
     },
     "42":{
        sortingKey:"(d. 1433/2012)",
        scholarName:"al-Sayyid Muḥammad ʿAlī al-Rawḍātī, al-ʿAllāma al-Rawḍātī ",
        death:"(d. 1433/2012)"
     },
     "43":{
        sortingKey:"(d. 1436/2015)",
        scholarName:"Yaḥyā al-Anṣārī al-Shīrāzī ",
        death:"(d. 1436/2015)"
     },
     "44":{
        sortingKey:"(d. 1437/2016)",
        scholarName:"Zīnat al-Sādāt ʿAlawiyya Humāyūnī, Bānū Humāyūnī ",
        death:"(d. 1437/2016)"
     },
     "45":{
        sortingKey:"(d. 1440/2018)",
        scholarName:"al-Sayyid Maḥmūd al-Hāshamī al-Shāhrūdī ",
        death:"(d. 1440/2018)"
     }
  }
}

function dynamicSort(property) {
  return function(a, b) {
    if (!b[property] || !a[property]) return 1;
    else return a[property].localeCompare(b[property]);
  };
}

export const sortedData = () => {
  let sortedScholarsDataBySortingKey = [];

  Object.values(scholarsDataObj).map((centuryObject, century) => {
    const sortedCenturyArray = Object.values(centuryObject).sort(
      dynamicSort("sortingKey")
    );
    sortedScholarsDataBySortingKey = [
      ...sortedScholarsDataBySortingKey,
      {
        [century + 2]: sortedCenturyArray
      }
    ];
  });
  return sortedScholarsDataBySortingKey;
};
